import React, { useState, useEffect, useRef } from 'react'
import addIcon from '../../../assets/images/icons/add.svg';
import { Link } from "react-router-dom";
import { Radio, Select, Col, Row, Input, Checkbox, Tooltip, Modal, Empty, TreeSelect } from "antd";
import backButton from '../../../assets/images/back_button_arrow.svg';
import siteIcon from '../../../assets/images/icons/site.svg';
import { SearchOutlined } from '@ant-design/icons';
import configData from "../../../config/config.json";
import demandIcon from '../../../assets/images/icons/demand_icon.svg';
import axios from "axios";
import FullLoader from "../../../assets/images/full-page-loader.gif";
import loaderIcon from "../../../assets/images/login-and-signup/loader.gif";
import { notifysuccess } from "../../../utils/toast";
import { notifyfailure } from "../../../utils/toast";
import { notifycatch } from "../../../utils/toast";
import Cookies from "js-cookie";

const { Option } = Select;
const { SHOW_PARENT } = TreeSelect;


const RemoteFeedViewEdit = ({ handlePageViewChange, handlePageViewEditBreadcrum, siteViewId, siteViewName, zoneViewId, zoneViewName, remoteFeedViewId, remoteFeedViewObjectId, remoteFeedViewName, callingFrom, typeRf }) => {


    const [formVisible, setFormVisible] = useState(false);
    const [buttonProcessing, setButtonProcessing] = useState(false);

    // const scrollToItem = (ref) => {
    //     if (ref && ref.current) {
    //         ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
    //     }
    // };

    const scrollToItem = (ref, offset = 80) => {
        if (ref && ref.current) {
            ref.current.style.scrollMarginTop = `${offset}px`;
            ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
            setTimeout(() => {
                ref.current.style.scrollMarginTop = '';
            }, 500);
        }
    };

    // --------------------------------------------------------------------------------------------------------------------------

    useEffect(() => {
        // setFeedId(zoneViewId);
        // setFeedExtra(siteViewId)

        let status = Cookies.get("token_xapads_ssp") ? true : false;
        if (status) {

            let token = Cookies.get("token_xapads_ssp");

            axios
                .get(configData.SERVER_URL + "remotefeed/remotefeedDetails?_id=" + remoteFeedViewObjectId, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                })
                .then((response) => {

                    setFeedType(response.data.data.feedType)
                    setName(response.data.data.name)
                    setCheckboxEnabled(response.data.data.isEnabled)
                    setNotes(response.data.data.notes)
                    setFeedHost(response.data.data.feed_host)
                    setFeedId(response.data.data.feed_id)
                    setFeedSubId(response.data.data.feed_subid)
                    setFeedAuth(response.data.data.feed_auth)
                    setFeedExtra(response.data.data.feed_extra)
                    setLogin(response.data.data.account_id)
                    setFeedToken(response.data.data.account_password)
                    setBidRevShare(response.data.data.revshare ? response.data.data.revshare : "")
                    setRevenueRevShare(response.data.data.revshare_revenue ? response.data.data.revshare_revenue : "")

                    setContact(response.data.data.contact)
                    setEmail(response.data.data.email)
                    setWebUrl(response.data.data.web_account_url)
                    setWebLogin(response.data.data.web_account_login)
                    setWebPassword(response.data.data.web_account_password)
                    setMinEcpm(response.data.data.min_ecpm ? response.data.data.min_ecpm : "")
                    setMaxEcpm(response.data.data.max_ecpm ? response.data.data.max_ecpm : "")
                    setExpectedQps(response.data.data.expected_qps ? response.data.data.expected_qps : "")
                    setMaxBidFloor(response.data.data.max_bidfloor ? response.data.data.max_bidfloor : "")
                    setUnderPay(response.data.data.underpay ? response.data.data.underpay : "")
                    setImpressionTypes(response.data.data.impression_types)
                    if (response.data.data.impression_types.includes("VIDEO")) {
                        setVideoPlayerSize(response.data.data.video_player_sizes)
                    }
                    if (response.data.data.impression_types.includes("BANNER")) {
                        setBannerSize(Array.isArray(response.data.data.banner_sizes) ? response.data.data.banner_sizes : [])
                    }
                    setTrafficType(response.data.data.traffic_type)
                    setInterstitialMatch(response.data.data.interstitial_match)

                    // if (Array.isArray(response.data.data.locations)) {
                    //     if (response.data.data.locations.length > 0) {
                    //         setCountryList(response.data.data.locations?.countries)

                    //     }
                    // }

                    if (Array.isArray(response.data.data.locations)) {
                        setCountryList(response.data.data.locations)
                    }


                    setReferrerListMode(response.data.data.referrerListMode)
                    if (response.data.data.referrerListMode !== "DISABLED") {
                        setReferrerList(response.data.data.referrerList)
                    }

                    setAppListMode(response.data.data.appListMode)
                    if (response.data.data.appListMode !== "DISABLED") {
                        setAppList(response.data.data.appList)
                    }

                    setDeviceIfaListMode(response.data.data.deviceifaListMode)
                    if (response.data.data.deviceifaListMode !== "DISABLED") {
                        setDeviceIfaList(response.data.data.deviceifaList)
                    }

                    setAppIdListMode(response.data.data.appIdListMode)
                    if (response.data.data.appIdListMode !== "DISABLED") {
                        setAppIdList(response.data.data.appIdList)
                    }

                    setIpListMode(response.data.data.ipListMode)
                    if (response.data.data.ipListMode !== "DISABLED") {
                        setIpList(response.data.data.ipList)
                    }

                    setTagListMode(response.data.data.tagIdListMode)
                    if (response.data.data.tagIdListMode !== "DISABLED") {
                        setTagList(response.data.data.tagIdList)
                    }

                    setOmidPartnersListMode(response.data.data.omid_partnersMode)
                    if (response.data.data.omid_partnersMode !== "DISABLED") {
                        setOmidPartnersList(response.data.data.omid_partnersList)
                    }

                    setDisplayManagersListMode(response.data.data.displayManagerListMode)
                    if (response.data.data.displayManagerListMode !== "DISABLED") {
                        setDisplayManagersList(response.data.data.displayManagerList)
                    }

                    setOsList(response.data.data.os)
                    setBrowserList(response.data.data.browsers)
                    setDeviceList(response.data.data.deviceTypes)
                    setDeviceBrandList(response.data.data.devicebrandModel)
                    setConnectionList(response.data.data.connection_type)
                    setCarriersList(response.data.data.carriers)
                    setCheckboxAutoIncludeNewBrowser(response.data.data.auto_enable_new_browsers)

                    setSellerMode(response.data.data.send_sellers_mode)
                    setMinSupplyChain(response.data.data.min_schain_length ? response.data.data.min_schain_length : "")
                    setMaxSupplyChain(response.data.data.max_schain_length ? response.data.data.max_schain_length : "")

                    setCheckboxNonEmptyReferer(response.data.data.referer_nonempty)
                    setCheckboxRefererMatch(response.data.data.referer_match)
                    setCheckboxNonEmptyApplication(response.data.data.app_nonempty)
                    setCheckboxAppBundleMatch(response.data.data.app_match)
                    setCheckboxIPMatch(response.data.data.ip_match)
                    setCheckboxGeoLocationMatch(response.data.data.geo_match)
                    setCheckboxValidUserAgent(response.data.data.ua_valid)
                    setCheckboxUserAgentMatch(response.data.data.ua_match)
                    setCheckboxNonRepeatedImpressions(response.data.data.filter_repeated_imp)
                    setCheckboxDiscountedImpressions(response.data.data.discounted_impressions)

                    setSeatListMode(response.data.data.seat_list_mode)
                    if (response.data.data.seat_list_mode !== "DISABLED") {
                        setSeatList(response.data.data.seat_list)
                    }

                    setCreativeListMode(response.data.data.cridlist_mode)
                    if (response.data.data.cridlist_mode !== "DISABLED") {
                        setCreativeList(response.data.data.crid_list)
                    }
                    setCheckboxCreativeSampling(response.data.data.is_sampling)

                    setCreativeApprovalMode(response.data.data.creative_approval_mode)
                    if (response.data.data.is_sampling) {
                        setAdQualitySystem(response.data.data.aq_system)
                        setDailyScans(response.data.data.scans_per_day ? response.data.data.scans_per_day : "")
                    }
                    setCheckboxNotifyProvider(response.data.data.notify_via_email)

                    setAverageRequestPerDay(response.data.data.requests_daily ? response.data.data.requests_daily : "")
                    setAverageImpressionPerDay(response.data.data.impressions_daily ? response.data.data.impressions_daily : "")
                    setImpressionPerIP(response.data.data.impressions_per_ip ? response.data.data.impressions_per_ip : "")
                    setClickPerIP(response.data.data.clicks_per_ip ? response.data.data.clicks_per_ip : "")

                    setTimeout(() => {
                        setFormVisible(true)
                    }, 200)
                })
                .catch((error) => {

                    setTimeout(() => {
                        setFormVisible(true)
                        notifyfailure("Failure in fetching remote feed data")
                    }, 200)
                });
        }



    }, [])

    useEffect(() => {

        axios
            .get(configData.SERVER_URL + "remotefeed/getBannerSizeList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setBannerSizeOptions(response.data.data)

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "ops/getCountryList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setCountryListOptions(response.data.data)

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "remotefeed/referrerlist", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setReferrerListOptions(response.data.data)

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "remotefeed/applist", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setAppListOptions(response.data.data)

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "remotefeed/deviceifaList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setDeviceIfaListOptions(response.data.data)

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "remotefeed/appIdList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setAppIdListOptions(response.data.data)

            })
            .catch((error) => { });



        axios
            .get(configData.SERVER_URL + "remotefeed/ipList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setIpListOptions(response.data.data)

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "remotefeed/tagList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setTagListOptions(response.data.data)

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "remotefeed/osList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setOsListOptions(response.data.data)

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "remotefeed/browserList", {
                headers: {
                    "Content-Type": "application/json",
                },
            })
            .then((response) => {
                setBrowserListOptions(response.data.data)

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "remotefeed/deviceBrandList", {
                headers: {
                    "Content-Type": "application/json",
                    // "x-access-token": token,
                },
            })
            .then((response) => {
                setDeviceBrandListOptions(response.data.data)

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "remotefeed/deviceTypeList", {
                headers: {
                    "Content-Type": "application/json",
                    // "x-access-token": token,
                },
            })
            .then((response) => {
                setDeviceListOptions(response.data.data)

            })
            .catch((error) => { });


        axios
            .get(configData.SERVER_URL + "remotefeed/connectionTypesList", {
                headers: {
                    "Content-Type": "application/json",
                    // "x-access-token": token,
                },
            })
            .then((response) => {
                setConnectionListOptions(response.data.data)

            })
            .catch((error) => { });

        axios
            .get(configData.SERVER_URL + "remotefeed/carrierListing", {
                headers: {
                    "Content-Type": "application/json",
                    // "x-access-token": token,
                },
            })
            .then((response) => {
                setCarriersListOptions(response.data.data)

            })
            .catch((error) => { });

    }, [])





    // ----------------------------------------------- General -----------------------------------------------------------------------

    const [feedType, setFeedType] = useState("");

    const [name, setName] = useState("");
    const [nameIsRequiredError, setNameIsRequiredError] = useState(false);

    const onChangeName = (e) => {

        setName(e.target.value);

        if (e.target.value?.length === 0) {
            setNameIsRequiredError(true)
        }
        else {
            setNameIsRequiredError(false)
        }
    };

    const onBlurName = (e) => {
        if (e.target.value.trim()?.length === 0) {
            setNameIsRequiredError(true)
        }

        setName(e.target.value.trim())
    };



    const [checkboxEnabled, setCheckboxEnabled] = useState(true);
    function onChangeCheckboxEnabled(event) {
        setCheckboxEnabled(event.target.checked);

        if (!event.target.checked) {
            setEmailIsRequiredError(false)
        }
    }


    const [notes, setNotes] = useState("");

    const onChangeNotes = (e) => {
        setNotes(e.target.value);
    };

    const onBlurNotes = (e) => {
        setNotes(e.target.value.trim());
    };


    // ----------------------------------------------- Feed Account -----------------------------------------------------------------------
    const regexDomain = /.+[.].+/;
    const regexEmail = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/


    const [feedHost, setFeedHost] = useState("");
    const [feedHostValidError, setFeedHostValidError] = useState(false);

    const onChangeFeedHost = (e) => {
        setFeedHost(e.target.value.trim());

        if (e.target.value.trim()?.length > 0) {

            if (!regexDomain.test(e.target.value.trim())) {
                setFeedHostValidError(true);
            }
            else {
                setFeedHostValidError(false);
            }
        }
        else {
            setFeedHostValidError(false)
        }
    };

    const onBlurFeedHost = (e) => {
        if (e.target.value.trim()?.length === 0) {
            setFeedHostValidError(false)
        }
        else {

            if (!regexDomain.test(e.target.value.trim())) {
                setFeedHostValidError(true);
            }
            else {
                setFeedHostValidError(false);
            }

        }

        setFeedHost(e.target.value.trim())
    };



    const [feedId, setFeedId] = useState("");
    const [feedIdIsRequiredError, setFeedIdIsRequiredError] = useState(false);

    const onChangeFeedId = (e) => {

        setFeedId(e.target.value);

        if (e.target.value?.length === 0) {
            setFeedIdIsRequiredError(true)
        }
        else {
            setFeedIdIsRequiredError(false)
        }
    };

    const onBlurFeedId = (e) => {
        if (e.target.value.trim()?.length === 0) {
            setFeedIdIsRequiredError(true)
        }

        setFeedId(e.target.value.trim())
    };
    const [feedSubId, setFeedSubId] = useState("");
    const [feedSubIdIsRequiredError, setFeedSubIdIsRequiredError] = useState(false);

    const onChangeFeedSubId = (e) => {
        setFeedSubId(e.target.value);

        if (e.target.value?.length === 0) {
            setFeedSubIdIsRequiredError(true)
        }
        else {
            setFeedSubIdIsRequiredError(false)
        }
    };

    const onBlurFeedSubId = (e) => {
        if (e.target.value.trim()?.length === 0) {
            setFeedSubIdIsRequiredError(true)
        }

        setFeedSubId(e.target.value.trim())
    };

    const [feedAuth, setFeedAuth] = useState("");

    const onChangeFeedAuth = (e) => {
        setFeedAuth(e.target.value);
    };

    const onBlurFeedAuth = (e) => {
        setFeedAuth(e.target.value.trim());
    };


    const [feedExtra, setFeedExtra] = useState("");
    const [feedExtraIsRequiredError, setFeedExtraIsRequiredError] = useState(false);

    const onChangeFeedExtra = (e) => {

        setFeedExtra(e.target.value);
        if (e.target.value?.length === 0) {
            setFeedExtraIsRequiredError(true)
        }
        else {
            setFeedExtraIsRequiredError(false)
        }
    };

    const onChangeFeedExtraFreewheel = (e) => {
        setFeedExtra(e.target.value);
    };

    const onBlurFeedExtra = (e) => {
        if (e.target.value.trim()?.length === 0) {
            setFeedExtraIsRequiredError(true)
        }

        setFeedExtra(e.target.value.trim())
    };

    const onBlurFeedExtraFreewheel = (e) => {
        setFeedExtra(e.target.value.trim())
    };

    const [login, setLogin] = useState("");

    const onChangeLogin = (e) => {
        setLogin(e.target.value);
    };

    const onBlurLogin = (e) => {
        setLogin(e.target.value.trim())
    };


    const [feedToken, setFeedToken] = useState("");

    const onChangeFeedToken = (e) => {
        setFeedToken(e.target.value);
    };

    const onBlurFeedToken = (e) => {
        setFeedToken(e.target.value.trim())
    };


    const [bidRevShare, setBidRevShare] = useState("100");
    const [revenueRevShare, setRevenueRevShare] = useState("100");

    const [contact, setContact] = useState("");

    const onChangeContact = (e) => {
        setContact(e.target.value);
    };

    const onBlurContact = (e) => {
        setContact(e.target.value.trim());
    };

    const [webLogin, setWebLogin] = useState("");

    const onChangeWebLogin = (e) => {
        setWebLogin(e.target.value);
    };

    const onBlurWebLogin = (e) => {
        setWebLogin(e.target.value.trim());
    };

    const [webPassword, setWebPassword] = useState("");

    const onChangeWebPassword = (e) => {
        setWebPassword(e.target.value);
    };

    const onBlurWebPassword = (e) => {
        setWebPassword(e.target.value.trim());
    };


    const [email, setEmail] = useState("");
    const [emailValidError, setEmailValidError] = useState(false);
    const [emailIsRequiredError, setEmailIsRequiredError] = useState(false);

    function onChangeEmail(event) {
        setEmail(event.target.value);

        setEmailValidError(false);
        setEmailIsRequiredError(false)

    }

    function onBlurEmail(event) {
        setEmail(event.target.value.trim());
        if (event.target.value.trim()?.length > 0) {
            if (!regexEmail.test(event.target.value.trim())) {
                setEmailValidError(true);
            }
            else {
                setEmailValidError(false);
            }
        }

    }


    const [webUrl, setWebUrl] = useState("");
    const [webUrlValidError, setWebUrlValidError] = useState(false);

    function onChangeWebUrl(event) {
        setWebUrl(event.target.value);

        setWebUrlValidError(false);

    }

    function onBlurWebUrl(event) {
        setWebUrl(event.target.value.trim());
        if (event.target.value.trim()?.length > 0) {
            if (!regexDomain.test(event.target.value.trim())) {
                setWebUrlValidError(true);
            }
            else {
                setWebUrlValidError(false);
            }
        }

    }

    // ----------------------------------------------- Optimisation -----------------------------------------------------------------------

    const [minEcpm, setMinEcpm] = useState("");
    const [minEcpmValueRangeError, setMinEcpmValueRangeError] = useState(false);
    function onChangeMinEcpm(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setMinEcpm(event.target.value.trim());


            if (maxEcpm === "") {
                setMaxEcpmValueError(false)

            }
            else {

                if (event.target.value.trim() !== "") {

                    if (Number(maxEcpm) < Number(event.target.value)) {
                        setMaxEcpmValueError(true)
                    }
                    else {
                        setMaxEcpmValueError(false)
                    }
                }
            }

            if (event.target.value.trim() === "") {
                setMaxEcpmValueError(false)
                setMinEcpmValueRangeError(false)
            }

            if (event.target.value.trim()?.length > 0) {
                if (Number(event.target.value.trim()) >= 0.00001 && Number(event.target.value.trim()) <= 50) {
                    setMinEcpmValueRangeError(false)
                }
                else {
                    setMinEcpmValueRangeError(true)
                }
            }

        }
    }


    const [maxEcpm, setMaxEcpm] = useState("");
    const [maxEcpmValueError, setMaxEcpmValueError] = useState(false);
    const [maxEcpmValueRangeError, setMaxEcpmValueRangeError] = useState(false);

    function onChangeMaxEcpm(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setMaxEcpm(event.target.value.trim());

            if (minEcpm === "") {
                setMaxEcpmValueError(false)

            }
            else {
                if (event.target.value.trim() !== "") {

                    if (Number(minEcpm) > Number(event.target.value)) {
                        setMaxEcpmValueError(true)
                    }
                    else {
                        setMaxEcpmValueError(false)
                    }
                }

            }

            if (event.target.value.trim() === "") {
                setMaxEcpmValueError(false)
                setMaxEcpmValueRangeError(false)
            }

            if (event.target.value.trim()?.length > 0) {
                if (Number(event.target.value.trim()) >= 0.00001 && Number(event.target.value.trim()) <= 50) {
                    setMaxEcpmValueRangeError(false)
                }
                else {
                    setMaxEcpmValueRangeError(true)
                }
            }

        }

    }

    const [maxBidFloor, setMaxBidFloor] = useState("");
    const [maxBidFloorValidError, setMaxBidFloorValidError] = useState(false);

    function onChangeMaxBidFloor(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setMaxBidFloor(event.target.value.trim());

            if (Number(event.target.value.trim()) >= 0.00001 && Number(event.target.value.trim()) <= 50) {
                setMaxBidFloorValidError(false)
            }
            else {
                setMaxBidFloorValidError(true)
            }
        }

        if (event.target.value.trim()?.length === 0) {
            setMaxBidFloorValidError(false)
        }
    }



    const [underPay, setUnderPay] = useState("1");
    const [underPayIsRequiredError, setUnderPayIsRequiredError] = useState(false);
    const [underPayValidError, setUnderPayValidError] = useState(false);

    function onChangeUnderPay(event) {
        if (/^\d*\.?\d*$/.test(event.target.value.trim())) {
            setUnderPay(event.target.value.trim());

            if (Number(event.target.value.trim()) >= 0.01 && Number(event.target.value.trim()) <= 1) {
                setUnderPayValidError(false)
            }
            else {
                setUnderPayValidError(true)
            }


            if (event.target.value.trim()?.length === 0) {
                setUnderPayValidError(false)
                setUnderPayIsRequiredError(true)
            }
            else {
                setUnderPayIsRequiredError(false)
            }
        }
    }





    const [expectedQps, setExpectedQps] = useState("");
    const [expectedQpsValidError, setExpectedQpsValidError] = useState(false);

    function onChangeExpectedQps(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setExpectedQps(event.target.value.trim());

            if (Number(event.target.value.trim()) >= 1 && Number(event.target.value.trim()) <= 500000) {
                setExpectedQpsValidError(false)
            }
            else {
                setExpectedQpsValidError(true)
            }
        }

        if (event.target.value.trim()?.length === 0) {
            setExpectedQpsValidError(false)
        }
    }


    // ----------------------------------------------- Targeting -----------------------------------------------------------------------

    const [impressionTypes, setImpressionTypes] = useState(['VIDEO']);
    const [impressionTypesOptions] = useState([{ label: "Banner", value: "BANNER" }, { label: "Native", value: "NATIVE" }, { label: "Audio", value: "AUDIO" }, { label: "Video", value: "VIDEO" }]);
    const [impressionTypesIsRequiredError, setImpressionTypesIsRequiredError] = useState(false);



    const [searchImpressionTypes, setSearchImpressionTypes] = useState('');

    const handleSearchImpressionTypes = (e) => {
        setSearchImpressionTypes(e.target.value.toLowerCase());
    };

    const filterImpressionTypes = impressionTypesOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchImpressionTypes)
    );

    function handleSelectAllImpressionTypes() {
        const allValues = impressionTypesOptions.map(option => option.value);
        let tempImpressionTypes = [];
        if (impressionTypes?.length !== impressionTypesOptions?.length) {
            tempImpressionTypes = [...allValues];
        } else {
            tempImpressionTypes = [];
        }

        if (tempImpressionTypes?.length === 0) {
            setImpressionTypesIsRequiredError(true)
        }
        else {
            setImpressionTypesIsRequiredError(false)
        }
        setImpressionTypes(tempImpressionTypes);
    }



    function handleImpressionTypes(value) {
        let tempImpressionTypes = [...impressionTypes]

        let newValue = [];
        if (tempImpressionTypes?.includes(value)) {
            newValue = tempImpressionTypes.filter((item) => item !== value);
        } else {
            newValue = [...tempImpressionTypes, value];
        }
        tempImpressionTypes = newValue


        if (tempImpressionTypes?.length === 0) {
            setImpressionTypesIsRequiredError(true)
        }
        else {
            setImpressionTypesIsRequiredError(false)
        }
        setImpressionTypes(tempImpressionTypes)

    }


    const [trafficType, setTrafficType] = useState("APP");
    const [trafficTypeOptions] = useState([{ label: "All", value: "ALL" }, { label: "Site", value: "SITE" }, { label: "App", value: "APP" }]);

    function onChangeTrafficType(event) {
        setTrafficType(event)
    }


    const [videoPlayerSize, setVideoPlayerSize] = useState(["SMALL", "MEDIUM", "LARGE"]);
    const [videoPlayerSizeIsRequiredError, setVideoPlayerSizeIsRequiredError] = useState(false);

    function onChangeVideoPlayerSize(event) {

        if (event?.length === 0) {
            setVideoPlayerSizeIsRequiredError(true)
        }
        else {
            setVideoPlayerSizeIsRequiredError(false)
        }
        setVideoPlayerSize(event)
    }

    const [bannerSize, setBannerSize] = useState([]);
    const [bannerSizeOptions, setBannerSizeOptions] = useState([]);
    const [bannerSizeIsRequiredError, setBannerSizeIsRequiredError] = useState(false);



    const [searchBannerSize, setSearchBannerSize] = useState('');

    const handleSearchBannerSize = (e) => {
        setSearchBannerSize(e.target.value.toLowerCase());
    };

    const filterBannerSize = bannerSizeOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchBannerSize)
    );

    function handleSelectAllBannerSize() {
        const allValues = bannerSizeOptions.map(option => option.value);
        let tempBannerSize = [];
        if (bannerSize?.length !== bannerSizeOptions?.length) {
            tempBannerSize = [...allValues];
        } else {
            tempBannerSize = [];
        }

        if (tempBannerSize?.length === 0) {
            setBannerSizeIsRequiredError(true)
        }
        else {
            setBannerSizeIsRequiredError(false)
        }
        setBannerSize(tempBannerSize);
    }



    function handleBannerSize(value) {
        let tempBannerSize = [...bannerSize]

        let newValue = [];
        if (tempBannerSize?.includes(value)) {
            newValue = tempBannerSize.filter((item) => item !== value);
        } else {
            newValue = [...tempBannerSize, value];
        }
        tempBannerSize = newValue


        if (tempBannerSize?.length === 0) {
            setBannerSizeIsRequiredError(true)
        }
        else {
            setBannerSizeIsRequiredError(false)
        }
        setBannerSize(tempBannerSize)

    }



    const [interstitialMatch, setInterstitialMatch] = useState("ANY");
    const [interstitialMatchOptions] = useState([{ label: "Any", value: "ANY" }, { label: "Interstitial", value: "INTERSTITIAL" }, { label: "Non Interstitial", value: "NON_INTERSTITIAL" }]);

    function onChangeInterstitialMatch(event) {
        setInterstitialMatch(event)
    }



    const [countryList, setCountryList] = useState([]);
    const [countryListOptions, setCountryListOptions] = useState([]);



    const [searchCountryList, setSearchCountryList] = useState('');

    const handleSearchCountryList = (e) => {
        setSearchCountryList(e.target.value.toLowerCase());
    };

    const filterCountryList = countryListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchCountryList)
    );

    function handleSelectAllCountryList() {
        const allValues = countryListOptions.map(option => option.value);
        let tempCountryList = [];
        if (countryList?.length !== countryListOptions?.length) {
            tempCountryList = [...allValues];
        } else {
            tempCountryList = [];
        }


        setCountryList(tempCountryList);
    }



    function handleCountryList(value) {
        let tempCountryList = [...countryList]

        let newValue = [];
        if (tempCountryList?.includes(value)) {
            newValue = tempCountryList.filter((item) => item !== value);
        } else {
            newValue = [...tempCountryList, value];
        }
        tempCountryList = newValue

        setCountryList(tempCountryList)

    }


    const [referrerListMode, setReferrerListMode] = useState("WHITELIST");
    const [referrerListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeReferrerListMode(event) {
        setReferrerListMode(event);
    }


    const [referrerList, setReferrerList] = useState([23823]);
    const [referrerListIsRequiredError, setReferrerListIsRequiredError] = useState(false);
    const [referrerListOptions, setReferrerListOptions] = useState([]);



    const [searchReferrerList, setSearchReferrerList] = useState('');

    const handleSearchReferrerList = (e) => {
        setSearchReferrerList(e.target.value.toLowerCase());
    };

    const filterReferrerList = referrerListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchReferrerList)
    );

    function handleSelectAllReferrerList() {
        const allValues = referrerListOptions.map(option => option.value);
        let tempReferrerList = [];
        if (referrerList?.length !== referrerListOptions?.length) {
            tempReferrerList = [...allValues];
            setReferrerListIsRequiredError(false)
        } else {
            tempReferrerList = [];
            setReferrerListIsRequiredError(true)
        }


        setReferrerList(tempReferrerList);
    }



    function handleReferrerList(value) {
        let tempReferrerList = [...referrerList]

        let newValue = [];
        if (tempReferrerList?.includes(value)) {
            newValue = tempReferrerList.filter((item) => item !== value);
        } else {
            newValue = [...tempReferrerList, value];
        }
        tempReferrerList = newValue

        if (tempReferrerList.length > 0) {
            setReferrerListIsRequiredError(false)
        }
        else {
            setReferrerListIsRequiredError(true)
        }

        setReferrerList(tempReferrerList)

    }

    const [appListMode, setAppListMode] = useState("WHITELIST");
    const [appListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeAppListMode(event) {
        setAppListMode(event);
    }

    const [appList, setAppList] = useState([]);
    const [appListIsRequiredError, setAppListIsRequiredError] = useState(false);
    const [appListOptions, setAppListOptions] = useState([]);



    const [searchAppList, setSearchAppList] = useState('');

    const handleSearchAppList = (e) => {
        setSearchAppList(e.target.value.toLowerCase());
    };

    const filterAppList = appListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchAppList)
    );

    function handleSelectAllAppList() {
        const allValues = appListOptions.map(option => option.value);
        let tempAppList = [];
        if (appList?.length !== appListOptions?.length) {
            tempAppList = [...allValues];
            setAppListIsRequiredError(false)
        } else {
            tempAppList = [];
            setAppListIsRequiredError(true)
        }


        setAppList(tempAppList);
    }



    function handleAppList(value) {
        let tempAppList = [...appList]

        let newValue = [];
        if (tempAppList?.includes(value)) {
            newValue = tempAppList.filter((item) => item !== value);
        } else {
            newValue = [...tempAppList, value];
        }
        tempAppList = newValue

        if (tempAppList.length > 0) {
            setAppListIsRequiredError(false)
        }
        else {
            setAppListIsRequiredError(true)
        }

        setAppList(tempAppList)

    }


    const [deviceIfaListMode, setDeviceIfaListMode] = useState("DISABLED");
    const [deviceIfaListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeDeviceIfaListMode(event) {
        setDeviceIfaListMode(event);
    }

    const [deviceIfaList, setDeviceIfaList] = useState([]);
    const [deviceIfaListIsRequiredError, setDeviceIfaListIsRequiredError] = useState(false);
    const [deviceIfaListOptions, setDeviceIfaListOptions] = useState([]);



    const [searchDeviceIfaList, setSearchDeviceIfaList] = useState('');

    const handleSearchDeviceIfaList = (e) => {
        setSearchDeviceIfaList(e.target.value.toLowerCase());
    };

    const filterDeviceIfaList = deviceIfaListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchDeviceIfaList)
    );

    function handleSelectAllDeviceIfaList() {
        const allValues = deviceIfaListOptions.map(option => option.value);
        let tempDeviceIfaList = [];
        if (deviceIfaList?.length !== deviceIfaListOptions?.length) {
            tempDeviceIfaList = [...allValues];
            setDeviceIfaListIsRequiredError(false)
        } else {
            tempDeviceIfaList = [];
            setDeviceIfaListIsRequiredError(true)
        }


        setDeviceIfaList(tempDeviceIfaList);
    }



    function handleDeviceIfaList(value) {
        let tempDeviceIfaList = [...deviceIfaList]

        let newValue = [];
        if (tempDeviceIfaList?.includes(value)) {
            newValue = tempDeviceIfaList.filter((item) => item !== value);
        } else {
            newValue = [...tempDeviceIfaList, value];
        }
        tempDeviceIfaList = newValue


        if (tempDeviceIfaList.length > 0) {
            setDeviceIfaListIsRequiredError(false)
        }
        else {
            setDeviceIfaListIsRequiredError(true)
        }


        setDeviceIfaList(tempDeviceIfaList)

    }

    const [appIdListMode, setAppIdListMode] = useState("DISABLED");
    const [appIdListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeAppIdListMode(event) {
        setAppIdListMode(event);
    }


    const [appIdList, setAppIdList] = useState([]);
    const [appIdListOptions, setAppIdListOptions] = useState([]);



    const [searchAppIdList, setSearchAppIdList] = useState('');

    const handleSearchAppIdList = (e) => {
        setSearchAppIdList(e.target.value.toLowerCase());
    };

    const filterAppIdList = appIdListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchAppIdList)
    );

    function handleSelectAllAppIdList() {
        const allValues = appIdListOptions.map(option => option.value);
        let tempAppIdList = [];
        if (appIdList?.length !== appIdListOptions?.length) {
            tempAppIdList = [...allValues];
        } else {
            tempAppIdList = [];
        }


        setAppIdList(tempAppIdList);
    }



    function handleAppIdList(value) {
        let tempAppIdList = [...appIdList]

        let newValue = [];
        if (tempAppIdList?.includes(value)) {
            newValue = tempAppIdList.filter((item) => item !== value);
        } else {
            newValue = [...tempAppIdList, value];
        }
        tempAppIdList = newValue

        setAppIdList(tempAppIdList)

    }

    const [ipListMode, setIpListMode] = useState("DISABLED");
    const [ipListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeIpListMode(event) {
        setIpListMode(event);
    }


    const [ipList, setIpList] = useState([]);
    const [ipListIsRequiredError, setIpListIsRequiredError] = useState(false);
    const [ipListOptions, setIpListOptions] = useState([]);



    const [searchIpList, setSearchIpList] = useState('');

    const handleSearchIpList = (e) => {
        setSearchIpList(e.target.value.toLowerCase());
    };

    const filterIpList = ipListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchIpList)
    );

    function handleSelectAllIpList() {
        const allValues = ipListOptions.map(option => option.value);
        let tempIpList = [];
        if (ipList?.length !== ipListOptions?.length) {
            tempIpList = [...allValues];
            setIpListIsRequiredError(false)
        } else {
            tempIpList = [];
            setIpListIsRequiredError(true)
        }


        setIpList(tempIpList);
    }



    function handleIpList(value) {
        let tempIpList = [...ipList]

        let newValue = [];
        if (tempIpList?.includes(value)) {
            newValue = tempIpList.filter((item) => item !== value);
        } else {
            newValue = [...tempIpList, value];
        }
        tempIpList = newValue

        if (tempIpList.length > 0) {
            setIpListIsRequiredError(false)
        }
        else {
            setIpListIsRequiredError(true)
        }


        setIpList(tempIpList)

    }
    const [tagListMode, setTagListMode] = useState("DISABLED");
    const [tagListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeTagListMode(event) {
        setTagListMode(event);
    }

    const [tagList, setTagList] = useState([]);
    const [tagListIsRequiredError, setTagListIsRequiredError] = useState(false);
    const [tagListOptions, setTagListOptions] = useState([]);



    const [searchTagList, setSearchTagList] = useState('');

    const handleSearchTagList = (e) => {
        setSearchTagList(e.target.value.toLowerCase());
    };

    const filterTagList = tagListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchTagList)
    );

    function handleSelectAllTagList() {
        const allValues = tagListOptions.map(option => option.value);
        let tempTagList = [];
        if (tagList?.length !== tagListOptions?.length) {
            tempTagList = [...allValues];
            setTagListIsRequiredError(false)
        } else {
            tempTagList = [];
            setTagListIsRequiredError(true)
        }


        setTagList(tempTagList);
    }



    function handleTagList(value) {
        let tempTagList = [...tagList]

        let newValue = [];
        if (tempTagList?.includes(value)) {
            newValue = tempTagList.filter((item) => item !== value);
        } else {
            newValue = [...tempTagList, value];
        }
        tempTagList = newValue

        if (tempTagList.length > 0) {
            setTagListIsRequiredError(false)
        }
        else {
            setTagListIsRequiredError(true)
        }


        setTagList(tempTagList)

    }








    const [omidPartnersListMode, setOmidPartnersListMode] = useState("DISABLED");
    const [omidPartnersListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeOmidPartnersListMode(event) {
        setOmidPartnersListMode(event);
    }


    const [omidPartnersList, setOmidPartnersList] = useState("");
    const [omidPartnersListIsRequiredError, setOmidPartnersListIsRequiredError] = useState(false);
    function onChangeOmidPartnersList(event) {
        setOmidPartnersListIsRequiredError(false)
        setOmidPartnersList(event.target.value);
    }

    function onBlurOmidPartnersList(event) {

        setOmidPartnersList(event.target.value.trim());
    }


    const [displayManagersListMode, setDisplayManagersListMode] = useState("DISABLED");
    const [displayManagersListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeDisplayManagersListMode(event) {
        setDisplayManagersListMode(event);
    }


    const [displayManagersList, setDisplayManagersList] = useState("");
    const [displayManagersListIsRequiredError, setDisplayManagersListIsRequiredError] = useState(false);
    function onChangeDisplayManagersList(event) {
        setDisplayManagersListIsRequiredError(false)
        setDisplayManagersList(event.target.value);
    }


    function onBlurDisplayManagersList(event) {

        setDisplayManagersList(event.target.value.trim());
    }





    //------------------------------------------Devices----------------------------------------------------------------------------------

    const [browserList, setBrowserList] = useState([]);
    const [browserListOptions, setBrowserListOptions] = useState([]);



    const [searchBrowswerList, setSearchBrowswerList] = useState('');

    const handleSearchBrowserList = (e) => {
        setSearchBrowswerList(e.target.value.toLowerCase());
    };

    const filterBrowserList = browserListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchBrowswerList)
    );

    function handleSelectAllBrowserList() {
        const allValues = browserListOptions.map(option => option.value);
        let tempBrowserList = [];
        if (browserList?.length !== browserListOptions?.length) {
            tempBrowserList = [...allValues];
        } else {
            tempBrowserList = [];
        }

        setBrowserList(tempBrowserList);
    }



    function handleBrowserList(value) {
        let tempBrowserList = [...browserList]

        let newValue = [];
        if (tempBrowserList?.includes(value)) {
            newValue = tempBrowserList.filter((item) => item !== value);
        } else {
            newValue = [...tempBrowserList, value];
        }
        tempBrowserList = newValue

        setBrowserList(tempBrowserList)

    }

    const [osList, setOsList] = useState([]);
    const [osListOptions, setOsListOptions] = useState([]);
    // const [searchOsList, setSearchOsList] = useState('');

    // const handleSearchOsList = (e) => {
    //     setSearchOsList(e.target.value?.toLowerCase());
    // };

    // const filterOsist = osListOptions.filter(option =>
    //     option?.title?.toLowerCase()?.includes(searchOsList)
    // );

    const handleOsList = (newValue) => {
        setOsList(newValue);
    };


    const handleSelectAllOsList = () => {
        if (osList.length === osListOptions.length) {
            setOsList([]);
        } else {
            setOsList(osListOptions.map((os) => os.value));
        }
    };


    const tPropsOs = {
        treeData: osListOptions,
        value: osList,
        onChange: handleOsList,
        treeCheckable: true,
        showCheckedStrategy: SHOW_PARENT,
        placeholder: "-Select-",
        displayRender: () => null,
        style: {
            width: "100%",
        },
        dropdownRender: (menu) => (
            <>
                {/* <div className="custom_inside_searchbar_d2">
                    <Input placeholder="Search" value={searchOsList} onChange={handleSearchOsList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                </div> */}
                <div className='select_all_d2'

                    onClick={() => handleSelectAllOsList()}
                >
                    <Checkbox
                        checked={osList?.length === osListOptions?.length}
                        onClick={(e) => e.stopPropagation()}
                    >
                        Select All
                    </Checkbox>
                </div>

                {menu}
            </>
        ),

        filterTreeNode: (inputValue, treeNode) => {
            const title = treeNode?.title?.toLowerCase();
            const searchValueLowerCase = inputValue?.toLowerCase();
            // const isSelected = selectedOsList.includes(treeNode.value);

            return title?.includes(searchValueLowerCase);
            //  || isSelected
        },

        // inputValue: searchOsList,
        // onSearch: (value) => setSearchOsList(value),
    };


    const [deviceList, setDeviceList] = useState([]);
    const [deviceListOptions, setDeviceListOptions] = useState([]);
    const [deviceListIsRequiredError, setDeviceListIsRequiredError] = useState(false);



    const [searchDeviceList, setSearchDeviceList] = useState('');

    const handleSearchDeviceList = (e) => {
        setSearchDeviceList(e.target.value.toLowerCase());
    };

    const filterDeviceList = deviceListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchDeviceList)
    );

    function handleSelectAllDeviceList() {
        const allValues = deviceListOptions.map(option => option.value);
        let tempDeviceList = [];
        if (deviceList?.length !== deviceListOptions?.length) {
            tempDeviceList = [...allValues];
        } else {
            tempDeviceList = [];
        }

        if (tempDeviceList?.length === 0) {
            setDeviceListIsRequiredError(true)
        }
        else {
            setDeviceListIsRequiredError(false)
        }
        setDeviceList(tempDeviceList);
    }



    function handleDeviceList(value) {
        let tempDeviceList = [...deviceList]

        let newValue = [];
        if (tempDeviceList?.includes(value)) {
            newValue = tempDeviceList.filter((item) => item !== value);
        } else {
            newValue = [...tempDeviceList, value];
        }
        tempDeviceList = newValue


        if (tempDeviceList?.length === 0) {
            setDeviceListIsRequiredError(true)
        }
        else {
            setDeviceListIsRequiredError(false)
        }
        setDeviceList(tempDeviceList)

    }



    const [deviceBrandList, setDeviceBrandList] = useState([]);
    const [deviceBrandListOptions, setDeviceBrandListOptions] = useState([]);



    const [searchDeviceBrandList, setSearchDeviceBrandList] = useState('');

    const handleSearchDeviceBrandList = (e) => {
        setSearchDeviceBrandList(e.target.value.toLowerCase());
    };

    const filterDeviceBrandList = deviceBrandListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchDeviceBrandList)
    );

    function handleSelectAllDeviceBrandList() {
        const allValues = deviceBrandListOptions.map(option => option.value);
        let tempDeviceBrandList = [];
        if (deviceBrandList?.length !== deviceBrandListOptions?.length) {
            tempDeviceBrandList = [...allValues];
        } else {
            tempDeviceBrandList = [];
        }

        setDeviceBrandList(tempDeviceBrandList);
    }



    function handleDeviceBrandList(value) {
        let tempDeviceBrandList = [...deviceBrandList]

        let newValue = [];
        if (tempDeviceBrandList?.includes(value)) {
            newValue = tempDeviceBrandList.filter((item) => item !== value);
        } else {
            newValue = [...tempDeviceBrandList, value];
        }
        tempDeviceBrandList = newValue

        setDeviceBrandList(tempDeviceBrandList)

    }


    const [connectionList, setConnectionList] = useState("ANY");
    const [connectionListOptions, setConnectionListOptions] = useState([]);

    function onChangeConnectionList(event) {
        setConnectionList(event)
    }



    // const [searchConnectionList, setSearchConnectionList] = useState('');

    // const handleSearchConnectionList = (e) => {
    //     setSearchConnectionList(e.target.value.toLowerCase());
    // };

    // const filterConnectionList = connectionListOptions.filter(option =>
    //     option.label.toLowerCase().includes(searchConnectionList)
    // );

    // function handleSelectAllConnectionList() {
    //     const allValues = connectionListOptions.map(option => option.value);
    //     let tempConnectionList = [];
    //     if (connectionList?.length !== connectionListOptions?.length) {
    //         tempConnectionList = [...allValues];
    //     } else {
    //         tempConnectionList = [];
    //     }
    //     setConnectionList(tempConnectionList);
    // }



    // function handleConnectionList(value) {
    //     let tempConnectionList = [...connectionList]

    //     let newValue = [];
    //     if (tempConnectionList.includes(value)) {
    //         newValue = tempConnectionList.filter((item) => item !== value);
    //     } else {
    //         newValue = [...tempConnectionList, value];
    //     }
    //     tempConnectionList = newValue

    //     setConnectionList(tempConnectionList)

    // }



    const [carriersList, setCarriersList] = useState([]);
    const [carriersListOptions, setCarriersListOptions] = useState([]);



    const [searchCarriersList, setSearchCarriersList] = useState('');

    const handleSearchCarriersList = (e) => {
        setSearchCarriersList(e.target.value.toLowerCase());
    };

    const filterCarriersList = carriersListOptions.filter(option =>
        option.label.toLowerCase()?.includes(searchCarriersList)
    );

    function handleSelectAllCarriersList() {
        const allValues = carriersListOptions.map(option => option.value);
        let tempCarriersList = [];
        if (carriersList?.length !== carriersListOptions?.length) {
            tempCarriersList = [...allValues];
        } else {
            tempCarriersList = [];
        }

        setCarriersList(tempCarriersList);
    }



    function handleCarriersList(value) {
        let tempCarriersList = [...carriersList]

        let newValue = [];
        if (tempCarriersList?.includes(value)) {
            newValue = tempCarriersList.filter((item) => item !== value);
        } else {
            newValue = [...tempCarriersList, value];
        }
        tempCarriersList = newValue

        setCarriersList(tempCarriersList)

    }

    const [checkboxAutoIncludeNewBrowser, setCheckboxAutoIncludeNewBrowser] = useState(true);

    function onChangeCheckboxAutoIncludeNewBrowser(event) {
        setCheckboxAutoIncludeNewBrowser(event.target.checked);
    }



    // ----------------------------------------------- Seller -----------------------------------------------------------------------

    const [sellerMode, setSellerMode] = useState("");
    const [sellerModeOptions] = useState([{ label: "All Nodes", value: "ALL" }, { label: "Only Last Node", value: "LAST_ONLY" }, { label: "None", value: "NONE" }]);

    function onChangeSellertMode(event) {
        setSellerMode(event);
    }



    const [minSupplyChain, setMinSupplyChain] = useState("");
    function onChangeMinSupplyChain(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setMinSupplyChain(event.target.value.trim());
        }

        if (maxSupplyChain === "") {
            setMaxSupplyChainValueError(false)
        }
        else {

            if (event.target.value.trim() !== "") {
                if (Number(maxSupplyChain) < Number(event.target.value)) {
                    setMaxSupplyChainValueError(true)
                }
                else {
                    setMaxSupplyChainValueError(false)
                }
            }
        }

        if (event.target.value.trim() === "") {
            setMaxSupplyChainValueError(false)
        }
    }

    const [maxSupplyChain, setMaxSupplyChain] = useState("");
    const [maxSupplyChainValueError, setMaxSupplyChainValueError] = useState(false);
    function onChangeMaxSupplyChain(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setMaxSupplyChain(event.target.value.trim());
        }

        if (minSupplyChain === "") {
            setMaxSupplyChainValueError(false)
        }
        else {
            if (event.target.value.trim() !== "") {
                if (Number(minSupplyChain) > Number(event.target.value)) {
                    setMaxSupplyChainValueError(true)
                }
                else {
                    setMaxSupplyChainValueError(false)
                }
            }
        }

        if (event.target.value.trim() === "") {
            setMaxSupplyChainValueError(false)
        }
    }

    // ----------------------------------------------- Filter -----------------------------------------------------------------------

    const [checkboxNonEmptyReferer, setCheckboxNonEmptyReferer] = useState(false);

    function onChangeCheckboxNonEmptyReferer(event) {
        setCheckboxNonEmptyReferer(event.target.checked);
    }

    const [checkboxRefererMatch, setCheckboxRefererMatch] = useState(false);

    function onChangeCheckboxRefererMatch(event) {
        setCheckboxRefererMatch(event.target.checked);
    }


    const [checkboxNonEmptyApplication, setCheckboxNonEmptyApplication] = useState(false);

    function onChangeCheckboxNonEmptyApplication(event) {
        setCheckboxNonEmptyApplication(event.target.checked);
    }

    const [checkboxAppBundleMatch, setCheckboxAppBundleMatch] = useState(false);

    function onChangeCheckboxAppBundleMatch(event) {
        setCheckboxAppBundleMatch(event.target.checked);
    }

    const [checkboxIPMatch, setCheckboxIPMatch] = useState(false);

    function onChangeCheckboxIPMatch(event) {
        setCheckboxIPMatch(event.target.checked);
    }

    const [checkboxGeoLocationMatch, setCheckboxGeoLocationMatch] = useState(false);

    function onChangeCheckboxGeoLocationMatch(event) {
        setCheckboxGeoLocationMatch(event.target.checked);
    }

    const [checkboxValidUserAgent, setCheckboxValidUserAgent] = useState(false);

    function onChangeCheckboxValidUserAgent(event) {
        setCheckboxValidUserAgent(event.target.checked);
    }

    const [checkboxUserAgentMatch, setCheckboxUserAgentMatch] = useState(false);

    function onChangeCheckboxUserAgentMatch(event) {
        setCheckboxUserAgentMatch(event.target.checked);
    }


    const [checkboxNonRepeatedImpressions, setCheckboxNonRepeatedImpressions] = useState(false);

    function onChangeCheckboxNonRepeatedImpressions(event) {
        setCheckboxNonRepeatedImpressions(event.target.checked);
    }


    const [checkboxDiscountedImpressions, setCheckboxDiscountedImpressions] = useState(false);

    function onChangeCheckboxDiscountedImpressions(event) {
        setCheckboxDiscountedImpressions(event.target.checked);
    }




    // ----------------------------------------------- Ad Quality -----------------------------------------------------------------------

    const [seatListMode, setSeatListMode] = useState("DISABLED");
    const [seatListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeSeatListMode(event) {
        setSeatListMode(event);
    }


    const [seatList, setSeatList] = useState("");
    const [seatListIsRequiredError, setSeatListIsRequiredError] = useState(false);
    function onChangeSeatList(event) {
        setSeatListIsRequiredError(false)
        setSeatList(event.target.value);
    }

    function onBlurSeatList(event) {

        setSeatList(event.target.value.trim());
    }


    const [creativeListMode, setCreativeListMode] = useState("DISABLED");
    const [creativeListModeOptions] = useState([{ label: "Disabled", value: "DISABLED" }, { label: "Whitelist", value: "WHITELIST" }, { label: "Blacklist", value: "BLACKLIST" }]);

    function onChangeCreativeListMode(event) {
        setCreativeListMode(event);
    }

    const [creativeList, setCreativeList] = useState("");
    const [creativeListIsRequiredError, setCreativeListIsRequiredError] = useState(false);
    function onChangeCreativeList(event) {
        setCreativeListIsRequiredError(false)
        setCreativeList(event.target.value);
    }

    function onBlurCreativeList(event) {

        setCreativeList(event.target.value.trim());
    }



    const [checkboxCreativeSampling, setCheckboxCreativeSampling] = useState(false);

    function onChangeCheckboxCreativeSampling(event) {

        if (event.target.checked === false) {
            setDailyScans("")
            setDailyScansIsRequiredError(false)
            setDailyScansValidError(false)
            // setCheckboxNotifyProvider(false)
        }
        setCheckboxCreativeSampling(event.target.checked);
    }

    const [creativeApprovalMode, setCreativeApprovalMode] = useState("ALLOW_ALL");
    const [creativeApprovalModeOptions] = useState([{ label: "Allow All", value: "ALLOW_ALL" }, { label: "Allow Approved Only", value: "ALLOW_APPROVED" }, { label: "Block Declined Only", value: "BLOCK_DECLINED" }]);


    function onChangeCreativeApprovalMode(event) {
        setCreativeApprovalMode(event);
    }


    const [adQualitySystem, setAdQualitySystem] = useState("TMT");
    const [adQualitySystemOptions] = useState([{ label: "The Media Trust", value: "TMT" }]);


    function onChangeAdQualitySystem(event) {
        setAdQualitySystem(event);
    }


    const [dailyScans, setDailyScans] = useState("");
    const [dailyScansIsRequiredError, setDailyScansIsRequiredError] = useState(false);
    const [dailyScansValidError, setDailyScansValidError] = useState(false);

    function onChangeDailyScans(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setDailyScans(event.target.value.trim());

            if (Number(event.target.value.trim()) >= 10 && Number(event.target.value.trim()) <= 10000) {
                setDailyScansValidError(false)
            }
            else {
                setDailyScansValidError(true)
            }
        }

        if (event.target.value.trim()?.length === 0) {
            setDailyScansValidError(false)
            setDailyScansIsRequiredError(true)
        }
        else {
            setDailyScansIsRequiredError(false)
        }
    }

    const [checkboxNotifyProvider, setCheckboxNotifyProvider] = useState(false);

    function onChangeCheckboxNotifyProvider(event) {
        setCheckboxNotifyProvider(event.target.checked);
    }



    const { TextArea } = Input;

    // ----------------------------------------------- Limits -----------------------------------------------------------------------

    const [averageRequestPerDay, setAverageRequestPerDay] = useState("");

    function onChangeAverageRequestPerDay(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setAverageRequestPerDay(event.target.value.trim());
        }
    }

    const [averageImpressionPerDay, setAverageImpressionPerDay] = useState("");

    function onChangeAverageImpressionPerDay(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setAverageImpressionPerDay(event.target.value.trim());
        }
    }

    function onBlurAverageImpressionPerDay(event) {
        if (event.target.value?.trim() !== "") {
            if (Number(event.target.value?.trim() > 2147483647)) {
                setAverageImpressionPerDay("2147483647")
            }
        }

    }
    const [impressionPerIP, setImpressionPerIP] = useState("");
    const [impressionPerIPIsValidError, setImpressionPerIPIsValidError] = useState(false);

    function onChangeAverageImpressionPerIP(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setImpressionPerIP(event.target.value.trim());

            if (event.target.value.trim() !== "") {
                if (Number(event.target.value?.trim()) >= 1 && Number(event.target.value?.trim()) <= 50) {
                    setImpressionPerIPIsValidError(false)
                }
                else {
                    setImpressionPerIPIsValidError(true)
                }
            }
            else {
                setImpressionPerIPIsValidError(false)
            }

        }


    }


    const [clickPerIP, setClickPerIP] = useState("");
    const [clickPerIPIsValidError, setClickPerIPIsValidError] = useState(false);

    function onChangeClickPerIP(event) {
        if (/^\d*$/.test(event.target.value.trim())) {
            setClickPerIP(event.target.value.trim());

            if (event.target.value.trim() !== "") {
                if (Number(event.target.value?.trim()) >= 1 && Number(event.target.value?.trim()) <= 50) {
                    setClickPerIPIsValidError(false)
                }
                else {
                    setClickPerIPIsValidError(true)
                }
            }
            else {
                setClickPerIPIsValidError(false)
            }

        }
    }







    // --------------------------------------------------------------------------------------------------------------------------


    const nameRef = useRef(null)
    const feedHostRef = useRef(null)
    const emailRef = useRef(null)
    const webUrlRef = useRef(null)
    const optimizationRef = useRef(null)
    const impressionTypesRef = useRef(null)
    const referrerListRef = useRef(null)
    const deviceIfaListRef = useRef(null)
    const ipListRef = useRef(null)
    const omidPartnersListRef = useRef(null)
    const displayManagersListRef = useRef(null)
    const deviceListRef = useRef(null)
    const sellerRef = useRef(null)
    const seatListRef = useRef(null)
    const creativeListRef = useRef(null)





    const errorDetect = () => {

        if (name.trim() === "") {
            scrollToItem(nameRef);
            return
        }

        if (feedHostValidError) {
            scrollToItem(feedHostRef);
            return
        }

        if (emailValidError) {
            scrollToItem(emailRef)
            return
        }
        if (webUrlValidError) {
            scrollToItem(webUrlRef)
            return
        }

        if (underPay === "" || minEcpmValueRangeError || maxEcpmValueRangeError || maxEcpmValueError || maxBidFloorValidError || underPayValidError || expectedQpsValidError) {
            scrollToItem(optimizationRef)
            return
        }

        if (impressionTypes.length === 0 || (impressionTypes?.includes("VIDEO") && videoPlayerSize.length === 0) || (impressionTypes?.includes("BANNER") && bannerSize.length === 0)) {
            scrollToItem(impressionTypesRef)
            return
        }

        if ((referrerListMode !== "DISABLED" && referrerList.length === 0) || (appListMode !== "DISABLED" && appList.length === 0)) {
            scrollToItem(referrerListRef)
            return
        }

        if (deviceIfaListMode !== "DISABLED" && deviceIfaList.length === 0) {
            scrollToItem(referrerListRef)
            return
        }

        if ((ipListMode !== "DISABLED" && ipList.length === 0) || (tagListMode !== "DISABLED" && tagList.length === 0)) {
            scrollToItem(ipListRef)
            return
        }

        if (omidPartnersListMode !== "DISABLED" && omidPartnersList.trim().length === 0) {
            scrollToItem(omidPartnersListRef)
            return
        }


        if (displayManagersListMode !== "DISABLED" && displayManagersList.trim().length === 0) {
            scrollToItem(displayManagersListRef)
            return
        }

        if (deviceList.length === 0) {
            scrollToItem(deviceListRef)
            return
        }

        if (maxSupplyChainValueError) {
            scrollToItem(sellerRef)
            return
        }

        if (seatListMode !== "DISABLED" && seatList.trim().length === 0) {
            scrollToItem(seatListRef)
            return
        }

        if (creativeListMode !== "DISABLED" && creativeList.trim().length === 0) {
            scrollToItem(creativeListRef)
            return
        }



    }

    const handleSubmit = async (e) => {
        e.preventDefault();

        errorDetect()

        if (
            name !== "" &&
            feedId !== "" &&
            (typeRf === "FreeWheel" ? true : feedExtra !== "") &&
            underPay !== "" &&
            (checkboxCreativeSampling ? dailyScans !== "" : true) &&
            (impressionTypes?.includes("VIDEO") ? videoPlayerSize?.length > 0 ? true : false : true) &&
            (impressionTypes?.includes("BANNER") ? bannerSize?.length > 0 ? true : false : true) &&
            (deviceIfaListMode !== "DISABLED" ? deviceIfaList?.length === 0 ? false : true : true) &&
            (ipListMode !== "DISABLED" ? ipList?.length === 0 ? false : true : true) &&
            (tagListMode !== "DISABLED" ? tagList?.length === 0 ? false : true : true) &&
            (appListMode !== "DISABLED" ? appList?.length === 0 ? false : true : true) &&
            (referrerListMode !== "DISABLED" ? referrerList?.length === 0 ? false : true : true) &&
            (omidPartnersListMode !== "DISABLED" ? omidPartnersList?.trim()?.length === 0 ? false : true : true) &&
            (displayManagersListMode !== "DISABLED" ? displayManagersList.trim().length === 0 ? false : true : true) &&
            (seatListMode !== "DISABLED" ? seatList.trim().length === 0 ? false : true : true) &&
            (creativeListMode !== "DISABLED" ? creativeList.trim().length === 0 ? false : true : true)
        ) {
            if (
                nameIsRequiredError === false &&
                feedHostValidError === false &&
                feedIdIsRequiredError === false &&
                (typeRf === "FreeWheel" ? true : feedExtraIsRequiredError === false) &&
                emailValidError === false &&
                webUrlValidError === false &&
                minEcpmValueRangeError === false &&
                maxEcpmValueError === false &&
                maxEcpmValueRangeError === false &&
                maxBidFloorValidError === false &&
                underPayValidError === false &&
                underPayIsRequiredError === false &&
                expectedQpsValidError === false &&
                dailyScansIsRequiredError === false &&
                dailyScansValidError === false &&
                deviceListIsRequiredError === false &&
                maxSupplyChainValueError === false &&
                impressionPerIPIsValidError === false &&
                clickPerIPIsValidError === false &&
                (impressionTypes?.includes("VIDEO") ? videoPlayerSizeIsRequiredError === false : true) &&
                (impressionTypes?.includes("BANNER") ? bannerSizeIsRequiredError === false : true) &&
                (deviceIfaListMode !== "DISABLED" ? deviceIfaListIsRequiredError === false : true) &&
                (ipListMode !== "DISABLED" ? ipListIsRequiredError === false : true) &&
                (tagListMode !== "DISABLED" ? tagListIsRequiredError === false : true) &&
                (appListMode !== "DISABLED" ? appListIsRequiredError === false : true) &&
                (referrerListMode !== "DISABLED" ? referrerListIsRequiredError === false : true) &&
                (omidPartnersListMode !== "DISABLED" ? omidPartnersListIsRequiredError === false : true) &&
                (displayManagersListMode !== "DISABLED" ? displayManagersListIsRequiredError === false : true) &&
                (seatListMode !== "DISABLED" ? seatListIsRequiredError === false : true) &&
                (creativeListMode !== "DISABLED" ? creativeListIsRequiredError === false : true)
            ) {

                if (checkboxNotifyProvider) {
                    if (email.trim() === "") {
                        setEmailIsRequiredError(true)
                        scrollToItem(emailRef)
                        // notifyfailure("Email can not be empty")
                        return
                    }

                }

                let payload = {
                    feedType: feedType,
                    zone: {
                        "label": zoneViewName,
                        "value": zoneViewId
                    },
                    name: name.trim(),
                    isEnabled: checkboxEnabled,
                    notes: notes.trim(),

                    feed_host: feedHost.trim(),
                    feed_id: feedId.trim(),
                    feed_subid: typeRf === "Pubmatic" ? feedSubId?.trim() : "",
                    feed_auth: feedAuth.trim(),
                    feed_extra: feedExtra.trim(),
                    account_id: login.trim(),
                    account_password: feedToken.trim(),
                    revshare: bidRevShare !== "" ? Number(bidRevShare) : "",
                    revshare_revenue: revenueRevShare !== "" ? Number(revenueRevShare) : "",
                    contact: contact.trim(),
                    email: email.trim(),
                    web_account_url: webUrl.trim(),
                    web_account_login: webLogin.trim(),
                    web_account_password: webPassword.trim(),

                    min_ecpm: minEcpm !== "" ? Number(minEcpm) : "",
                    max_ecpm: maxEcpm !== "" ? Number(maxEcpm) : "",
                    expected_qps: expectedQps !== "" ? Number(expectedQps) : "",
                    max_bidfloor: maxBidFloor !== "" ? Number(maxBidFloor) : "",
                    underpay: underPay !== "" ? Number(underPay) : "",
                    expectedQps: expectedQps !== "" ? Number(expectedQps) : "",

                    impression_types: impressionTypes,
                    traffic_type: trafficType,
                    video_player_sizes: impressionTypes?.includes("VIDEO") ? videoPlayerSize : [],
                    banner_sizes: impressionTypes?.includes("BANNER") ? bannerSize : [],
                    interstitial_match: interstitialMatch,
                    locations: countryList,
                    referrerListMode: referrerListMode,
                    referrerList: referrerListMode === "DISABLED" ? "" : referrerList,
                    appListMode: appListMode,
                    appList: appListMode === "DISABLED" ? "" : appList,
                    deviceifaListMode: deviceIfaListMode,
                    deviceifaList: deviceIfaListMode === "DISABLED" ? "" : deviceIfaList,
                    ipListMode: ipListMode,
                    ipList: ipListMode === "DISABLED" ? "" : ipList,
                    tagIdListMode: tagListMode,
                    tagIdList: tagListMode === "DISABLED" ? "" : tagList,
                    appIdListMode: appIdListMode,
                    appIdList: appIdListMode === "DISABLED" ? "" : appIdList,
                    omid_partnersMode: omidPartnersListMode,
                    omid_partnersList: omidPartnersListMode === "DISABLED" ? "" : omidPartnersList,
                    displayManagerListMode: displayManagersListMode,
                    displayManagerList: displayManagersListMode === "DISABLED" ? "" : displayManagersList,



                    os: osList,
                    browsers: browserList,
                    deviceTypes: deviceList,
                    devicebrandModel: deviceBrandList,
                    connection_type: connectionList,
                    carriers: carriersList,
                    auto_enable_new_browsers: checkboxAutoIncludeNewBrowser,

                    send_sellers_mode: sellerMode,
                    min_schain_length: minSupplyChain !== "" ? Number(minSupplyChain) : "",
                    max_schain_length: maxSupplyChain !== "" ? Number(maxSupplyChain) : "",

                    referer_nonempty: checkboxNonEmptyReferer,
                    referer_match: checkboxRefererMatch,
                    app_nonempty: checkboxNonEmptyApplication,
                    app_match: checkboxAppBundleMatch,
                    ip_match: checkboxIPMatch,
                    geo_match: checkboxGeoLocationMatch,
                    ua_valid: checkboxValidUserAgent,
                    ua_match: checkboxUserAgentMatch,
                    filter_repeated_imp: checkboxNonRepeatedImpressions,
                    discounted_impressions: checkboxDiscountedImpressions,

                    seat_list_mode: seatListMode,
                    seat_list: seatListMode === "DISABLED" ? "" : seatList,
                    cridlist_mode: creativeListMode,
                    crid_list: creativeListMode === "DISABLED" ? "" : creativeList,

                    is_sampling: checkboxCreativeSampling,
                    creative_approval_mode: creativeApprovalMode,
                    aq_system: checkboxCreativeSampling ? adQualitySystem : "",
                    scans_per_day: checkboxCreativeSampling ? Number(dailyScans) : "",
                    notify_via_email: checkboxNotifyProvider,

                    requests_daily: averageRequestPerDay !== "" ? Number(averageRequestPerDay) : "",
                    impressions_daily: averageImpressionPerDay !== "" ? Number(averageImpressionPerDay) : "",
                    impressions_per_ip: impressionPerIP !== "" ? Number(impressionPerIP) : "",
                    clicks_per_ip: clickPerIP !== "" ? Number(clickPerIP) : "",
                }



                setButtonProcessing(true)


                let status = Cookies.get("token_xapads_ssp") ? true : false;
                if (status) {

                    let token = Cookies.get("token_xapads_ssp");

                    axios
                        .put(configData.SERVER_URL + `remotefeed/editRF?_id=` + remoteFeedViewObjectId, payload, {
                            headers: {
                                'Content-Type': 'application/json',
                                "x-access-token": token,
                            },
                        })
                        .then((response) => {
                            notifysuccess(response.data.message);
                            setTimeout(() => {
                                handlePageViewChange("table", "yes")
                            }, 1000)

                        })
                        .catch((error) => {
                            if (error?.response) {
                                if (error.response.data.message?.length !== 0) {
                                    notifyfailure(error.response.data.message);
                                    setButtonProcessing(false)
                                }
                            } else {
                                notifycatch();
                                setButtonProcessing(false)
                            }

                        });
                }



            }
        } else {

            if (name === "") {
                setNameIsRequiredError(true)
            }

            if (feedId === "") {
                setFeedIdIsRequiredError(true)
            }
            if (typeRf !== "FreeWheel" && feedExtra === "") {
                setFeedExtraIsRequiredError(true)
            }

            if (underPay === "") {
                setUnderPayIsRequiredError(true)
            }


            if (checkboxCreativeSampling && dailyScans === "") {
                setDailyScansIsRequiredError(true)
            }


            if (impressionTypes?.includes("VIDEO") && videoPlayerSize?.length === 0) {
                setVideoPlayerSizeIsRequiredError(true)
            }

            if (impressionTypes?.includes("BANNER") && bannerSize?.length === 0) {
                setBannerSizeIsRequiredError(true)
            }

            if (deviceIfaListMode !== "DISABLED" && deviceIfaList?.length === 0) {
                setDeviceIfaListIsRequiredError(true)
            }

            if (ipListMode !== "DISABLED" && ipList?.length === 0) {
                setIpListIsRequiredError(true)
            }

            if (tagListMode !== "DISABLED" && tagList?.length === 0) {
                setTagListIsRequiredError(true)
            }

            if (appListMode !== "DISABLED" && appList?.length === 0) {
                setAppListIsRequiredError(true)
            }

            if (referrerListMode !== "DISABLED" && referrerList?.length === 0) {
                setReferrerListIsRequiredError(true)
            }

            if (omidPartnersListMode !== "DISABLED" && omidPartnersList?.trim()?.length === 0) {
                setOmidPartnersListIsRequiredError(true)
            }

            if (displayManagersListMode !== "DISABLED" && displayManagersList.trim().length === 0) {
                setDisplayManagersListIsRequiredError(true)
            }

            if (seatListMode !== "DISABLED" && seatList.trim().length === 0) {
                setSeatListIsRequiredError(true)
            }

            if (creativeListMode !== "DISABLED" && creativeList.trim().length === 0) {
                setCreativeListIsRequiredError(true)
            }



        }
    }


    return (
        <>
            <div className="container_box--wrapper pt_header">
                {callingFrom !== "rfListing" &&
                    <div className="container_box--breadcrumb">
                        <ul className="container_box--breadcrumb-list">
                            <li className="">   <Link onClick={() => {
                                handlePageViewEditBreadcrum("table", "sites")
                            }}>
                                <img src={demandIcon} alt='USP' />
                                {typeRf}
                            </Link></li>
                            <li className=""><Link onClick={() => {
                                handlePageViewChange("table", "no")
                            }}>{zoneViewName} - {zoneViewId}</Link> </li>
                            <li className="primary">Edit Remote Feed</li>
                        </ul>
                    </div>
                }
                <div className="container_box--wrapper--title d_flex justify-content-between">
                    <div className="back_btn_d2">
                        <img src={backButton} className="img-fluid" alt=""
                            onClick={() => {
                                handlePageViewChange("table", "no")
                            }}
                        />
                        <h1 className="heading">
                            {remoteFeedViewName + " (" + remoteFeedViewId + ")"}
                        </h1>
                    </div>
                </div>
                {formVisible &&
                    <div className="container_box--content pt_20">
                        <div className="container_box--width">

                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Zone</label>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container border-0 p-0">
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className="form_content_block--group hide_caret_after_select_value m-0">
                                                    <p className='m-0 zone_label_text'>{zoneViewName} ({zoneViewId}) </p>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>

                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>General</label>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                    <label className="form_label">Feed Type *</label>
                                                    <Input className='form_control basic' autocomplete="off"
                                                        value={feedType?.label}
                                                        disabled
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value" ref={nameRef}>
                                                    <label className="form_label">Name *</label>
                                                    <Input className={nameIsRequiredError ? 'form_control basic error' : 'form_control basic'} autocomplete="off"
                                                        value={name}
                                                        onChange={onChangeName}
                                                        onBlur={onBlurName}
                                                    />
                                                    <span className="error_content">{nameIsRequiredError && <>This field is required</>} </span>
                                                </div>
                                                <div className="form_content_block--group">
                                                    <div className="primary_checkbox">
                                                        <Checkbox id="checkboxEnabled" name="checkboxEnabled"
                                                            checked={checkboxEnabled}
                                                            onChange={onChangeCheckboxEnabled}
                                                        >
                                                            <span className="form_label">
                                                                Enabled
                                                            </span>
                                                        </Checkbox>
                                                    </div>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value mb-0">
                                                    <label className="form_label">Notes</label>
                                                    <TextArea className='form_control basic form_control_h --80 textarea_paddingY_d2' autocomplete="off"
                                                        value={notes}
                                                        onChange={onChangeNotes}
                                                        onBlur={onBlurNotes}
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>


                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Feed Account</label>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className="form_content_block--group hide_caret_after_select_value" ref={feedHostRef}>
                                                    <label className="form_label">Override Feed Host </label>
                                                    <Input className={feedHostValidError ? 'form_control basic error' : 'form_control basic '} autocomplete="off"
                                                        value={feedHost}
                                                        onChange={onChangeFeedHost}
                                                        onBlur={onBlurFeedHost}
                                                    />
                                                    <span className="error_content">


                                                        {feedHostValidError && <>Invalid Feed Host</>}

                                                    </span>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                    <label className="form_label">Feed ID *</label>
                                                    <Input className={feedIdIsRequiredError ? 'form_control basic error' : 'form_control basic'} autocomplete="off"
                                                        value={feedId}
                                                        onChange={onChangeFeedId}
                                                        onBlur={onBlurFeedId}
                                                        disabled
                                                    />
                                                    <span className="error_content">{feedIdIsRequiredError && <>This field is required</>} </span>
                                                </div>
                                                {typeRf === "Pubmatic" &&
                                                    <div className="form_content_block--group hide_caret_after_select_value">
                                                        <label className="form_label">Feed SubID </label>
                                                        <Input className={feedSubIdIsRequiredError ? 'form_control basic error' : 'form_control basic'} autocomplete="off"
                                                            value={feedSubId}
                                                            onChange={onChangeFeedSubId}
                                                            onBlur={onBlurFeedSubId}
                                                            disabled
                                                        />
                                                        <span className="error_content">{feedSubIdIsRequiredError && <>This field is required</>} </span>
                                                    </div>
                                                }
                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                    <label className="form_label">Feed Auth </label>
                                                    <Input className='form_control basic' autocomplete="off"
                                                        value={feedAuth}
                                                        onChange={onChangeFeedAuth}
                                                        onBlur={onBlurFeedAuth}
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                    {typeRf === "Pubmatic" ?
                                                        <>
                                                            <label className="form_label">Feed Extra * </label>
                                                            <Input className={feedExtraIsRequiredError ? 'form_control basic error' : 'form_control basic'} autocomplete="off"
                                                                value={feedExtra}
                                                                onChange={onChangeFeedExtra}
                                                                onBlur={onBlurFeedExtra}
                                                                disabled
                                                            />
                                                            <span className="error_content"> {feedExtraIsRequiredError && <>This field is required</>}</span>
                                                        </>
                                                        :
                                                        <>
                                                            <label className="form_label">Feed Extra </label>
                                                            <Input className='form_control basic' autocomplete="off"
                                                                value={feedExtra}
                                                                onChange={onChangeFeedExtraFreewheel}
                                                                onBlur={onBlurFeedExtraFreewheel}
                                                            />
                                                            <span className="error_content"></span>
                                                        </>
                                                    }
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                    <label className="form_label">Stats Login/ID  </label>
                                                    <Input className='form_control basic' autocomplete="off"
                                                        value={login}
                                                        onChange={onChangeLogin}
                                                        onBlur={onBlurLogin}
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                    <label className="form_label">Stats Password/Token  </label>
                                                    <Input className='form_control basic' autocomplete="off"
                                                        value={feedToken}
                                                        onChange={onChangeFeedToken}
                                                        onBlur={onBlurFeedToken}
                                                    // disabled={typeRf === "FreeWheel"}
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                    <Row gutter={16}>
                                                        <Col span={12}>
                                                            <div className="form_content_block--group mb_0">
                                                                <label className="form_label">Bids' Revshare (%)</label>
                                                                <Input className='form_control basic' value={bidRevShare} disabled autocomplete="off" />
                                                            </div>
                                                            <span className="error_content"></span>
                                                        </Col>
                                                        <Col span={12}>
                                                            <div className="form_content_block--group mb_0">
                                                                <label className="form_label">Revenue Revshare  (%)</label>
                                                                <Input className='form_control basic' value={revenueRevShare} disabled autocomplete="off" />
                                                                <span className="error_content"></span>
                                                            </div>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                    <label className="form_label">Contact </label>
                                                    <Input className='form_control basic' autocomplete="off"
                                                        value={contact}
                                                        onChange={onChangeContact}
                                                        onBlur={onBlurContact}
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value" ref={emailRef}>
                                                    <label className="form_label">Email </label>
                                                    <Input className={emailValidError || emailIsRequiredError ? 'form_control basic error' : 'form_control basic'} autocomplete="off"
                                                        value={email}
                                                        onChange={onChangeEmail}
                                                        onBlur={onBlurEmail}
                                                    />
                                                    <span className="error_content">{emailValidError && <>Invalid Email</>}
                                                        {emailIsRequiredError && <>Email can not be empty when Notify Provider via E-mail is checked</>}
                                                    </span>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value" ref={webUrlRef}>
                                                    <label className="form_label">Web Account URL </label>
                                                    <Input className={webUrlValidError ? 'form_control basic error' : 'form_control basic'} autocomplete="off"
                                                        value={webUrl}
                                                        onChange={onChangeWebUrl}
                                                        onBlur={onBlurWebUrl}
                                                    />
                                                    <span className="error_content">{webUrlValidError && <>Invalid Url</>} </span>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                    <label className="form_label">Web Account Login </label>
                                                    <Input className='form_control basic' autocomplete="off"
                                                        value={webLogin}
                                                        onChange={onChangeWebLogin}
                                                        onBlur={onBlurWebLogin}
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value mb-0">
                                                    <label className="form_label">Web Account Password </label>
                                                    <Input className='form_control basic' autocomplete="off"
                                                        value={webPassword}
                                                        onChange={onChangeWebPassword}
                                                        onBlur={onBlurWebPassword}
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>

                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Optimization</label>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container" ref={optimizationRef}>
                                        <Row gutter={16}>
                                            <Col span={12}>
                                                <div className="form_content_block--group prefixIconCss_d2">
                                                    <label className="form_label">Min eCPM</label>
                                                    <Input className={minEcpmValueRangeError ? 'form_control basic error' : 'form_control basic'} autocomplete="off" prefix={'$'}
                                                        value={minEcpm}
                                                        onChange={onChangeMinEcpm}

                                                    />
                                                    <span className="error_content"> {minEcpmValueRangeError && <>Value must be between 0.00001 and 50</>}</span>
                                                </div>
                                            </Col>
                                            <Col span={12}>
                                                <div className="form_content_block--group prefixIconCss_d2">
                                                    <label className="form_label">Max eCPM</label>
                                                    <Input className={maxEcpmValueRangeError ? 'form_control basic error' : 'form_control basic'} autocomplete="off" prefix={'$'}
                                                        value={maxEcpm}
                                                        onChange={onChangeMaxEcpm}
                                                    />
                                                    <span className="error_content">
                                                        {maxEcpmValueRangeError && <>Value must be between 0.00001 and 50<br /></>}

                                                        {maxEcpmValueError && <> Min eCpm must be smaller or equal than max eCpm </>}
                                                    </span>
                                                </div>
                                            </Col>
                                            <Col span={24}>
                                                <div className="form_content_block--group prefixIconCss_d2">
                                                    <label className="form_label">Max Bidfloor</label>
                                                    <Input className={maxBidFloorValidError ? 'form_control basic error' : 'form_control basic'} autocomplete="off" prefix={'$'}
                                                        value={maxBidFloor}
                                                        onChange={onChangeMaxBidFloor}
                                                    />
                                                    <span className="error_content"> {maxBidFloorValidError && <>Value must be between 0.00001 and 50</>}</span>
                                                </div>
                                                <div className="form_content_block--group prefixIconCss_d2">
                                                    <label className="form_label">Underpay *</label>
                                                    <Input className={(underPayValidError || underPayIsRequiredError) ? 'form_control basic error' : 'form_control basic'} autocomplete="off"
                                                        value={underPay}
                                                        onChange={onChangeUnderPay}
                                                    />
                                                    <span className="error_content">
                                                        {underPayIsRequiredError && <>This field is required</>}
                                                        {underPayValidError && <>Value must be between  0.01 and 1</>} </span>
                                                </div>
                                                <div className="form_content_block--group prefixIconCss_d2">
                                                    <label className="form_label">Expected QPS</label>
                                                    <Input className={expectedQpsValidError ? 'form_control basic error' : 'form_control basic'} placeholder='' autocomplete="off"
                                                        value={expectedQps}
                                                        onChange={onChangeExpectedQps}
                                                    />
                                                    <span className="error_content">{expectedQpsValidError && <>Value must be between 1 and 500000</>} </span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>


                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Targeting</label>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <Row gutter={16}>
                                            <Col span={24}>
                                                <div className="form_content_block--group hide_caret_after_select_value" ref={impressionTypesRef}>
                                                    <label className="form_label">Impression Types *</label>
                                                    <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                        {typeRf === "FreeWheel" ?
                                                            <Select
                                                                id="impressionTypes"
                                                                value={impressionTypes}
                                                                // disabled={true}
                                                                popupClassName='diff_select_d2 --full'
                                                                showSearch={false}
                                                                disabled
                                                                placeholder='- Select -'
                                                                className={impressionTypesIsRequiredError ? "form_select basic error" : "form_select basic"}
                                                                mode='multiple'
                                                                maxTagCount='responsive'

                                                                dropdownRender={menu => (
                                                                    <>
                                                                        <div className="custom_inside_searchbar_d2">
                                                                            <Input placeholder="Search" value={searchImpressionTypes} onChange={handleSearchImpressionTypes} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                        </div>
                                                                        <div className='select_all_d2'
                                                                            onClick={() => handleSelectAllImpressionTypes()}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                checked={impressionTypes?.length === impressionTypesOptions?.length}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                Select All
                                                                            </Checkbox>
                                                                        </div>

                                                                        {menu}
                                                                    </>
                                                                )}
                                                            >
                                                                {[
                                                                    ...filterImpressionTypes?.filter(option => impressionTypes?.includes(option.value)), // Checked options first
                                                                    ...filterImpressionTypes?.filter(option => !impressionTypes?.includes(option.value)) // Unchecked options next
                                                                ].map(option => (
                                                                    <Option key={option.value} value={option.value}>
                                                                        <div
                                                                            onClick={() => handleImpressionTypes(option.value)}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                checked={impressionTypes?.includes(option.value)}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                {option.label}
                                                                            </Checkbox>
                                                                        </div>
                                                                    </Option>
                                                                ))}
                                                            </Select>

                                                            :
                                                            typeRf === "Pubmatic" ?
                                                                <Select
                                                                    id="impressionTypes"
                                                                    value={impressionTypes}
                                                                    // disabled={true}
                                                                    popupClassName='diff_select_d2 --full'
                                                                    showSearch={false}
                                                                    placeholder='- Select -'
                                                                    className={impressionTypesIsRequiredError ? "form_select basic error" : "form_select basic"}
                                                                    mode='multiple'
                                                                    maxTagCount='responsive'

                                                                    dropdownRender={menu => (
                                                                        <>
                                                                            <div className="custom_inside_searchbar_d2">
                                                                                <Input placeholder="Search" value={searchImpressionTypes} onChange={handleSearchImpressionTypes} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                            </div>
                                                                            <div className='select_all_d2'
                                                                                onClick={() => handleSelectAllImpressionTypes()}
                                                                                style={{ display: 'flex', alignItems: 'center' }}
                                                                            >
                                                                                <Checkbox
                                                                                    checked={impressionTypes?.length === impressionTypesOptions?.length}
                                                                                    onClick={(e) => e.stopPropagation()}
                                                                                >
                                                                                    Select All
                                                                                </Checkbox>
                                                                            </div>

                                                                            {menu}
                                                                        </>
                                                                    )}
                                                                >
                                                                    {[
                                                                        ...filterImpressionTypes?.filter(option => impressionTypes?.includes(option.value)), // Checked options first
                                                                        ...filterImpressionTypes?.filter(option => !impressionTypes?.includes(option.value)) // Unchecked options next
                                                                    ].map(option => (
                                                                        <Option key={option.value} value={option.value}>
                                                                            <div
                                                                                onClick={() => handleImpressionTypes(option.value)}
                                                                                style={{ display: 'flex', alignItems: 'center' }}
                                                                            >
                                                                                <Checkbox
                                                                                    checked={impressionTypes?.includes(option.value)}
                                                                                    onClick={(e) => e.stopPropagation()}
                                                                                >
                                                                                    {option.label}
                                                                                </Checkbox>
                                                                            </div>
                                                                        </Option>
                                                                    ))}
                                                                </Select>
                                                                :
                                                                <></>
                                                        }
                                                    </div>
                                                    <span className="error_content"> {impressionTypesIsRequiredError && <>Minimum 1 selection required</>}</span>
                                                </div>
                                                <div className="form_content_block--group  hide_caret_after_select_value">
                                                    <label className="form_label">Traffic Type * </label>
                                                    <Select
                                                        showSearch
                                                        className='form_select basic no_search'
                                                        placeholder="-Select-"
                                                        optionFilterProp="label"
                                                        onChange={onChangeTrafficType}
                                                        value={trafficType}
                                                        options={trafficTypeOptions}
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                                {impressionTypes?.includes("VIDEO") &&
                                                    <div className="form_content_block--group">
                                                        <label className="form_label">
                                                            Video Player Sizes *
                                                        </label>
                                                        <div className='new_cls_for_checkboxgroup_d2'>
                                                            <Checkbox.Group className="form_checkbox equal_space" value={videoPlayerSize} onChange={onChangeVideoPlayerSize}>
                                                                <Checkbox className="checkbox_btn" value="SMALL">
                                                                    Small
                                                                </Checkbox>
                                                                <Checkbox className="checkbox_btn" value="MEDIUM">
                                                                    Medium
                                                                </Checkbox>
                                                                <Checkbox className="checkbox_btn" value="LARGE">
                                                                    Large
                                                                </Checkbox>
                                                            </Checkbox.Group>
                                                        </div>
                                                        <span className="error_content">{videoPlayerSizeIsRequiredError && <> Minimum 1 selection is required</>} </span>
                                                    </div>
                                                }


                                                {impressionTypes?.includes("BANNER") &&
                                                    <div className="form_content_block--group hide_caret_after_select_value" >
                                                        <label className="form_label"> Banner Sizes *</label>
                                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>

                                                            <Select
                                                                id="bannerSizes"
                                                                value={bannerSize}
                                                                // disabled={true}
                                                                popupClassName='diff_select_d2 --full'
                                                                showSearch={true}

                                                                placeholder='- Select -'
                                                                className={bannerSizeIsRequiredError ? "form_select basic error" : "form_select basic"}
                                                                mode='multiple'
                                                                maxTagCount='responsive'

                                                                dropdownRender={menu => (
                                                                    <>
                                                                        <div className="custom_inside_searchbar_d2">
                                                                            <Input placeholder="Search" value={searchBannerSize} onChange={handleSearchBannerSize} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                        </div>
                                                                        <div className='select_all_d2'
                                                                            onClick={() => handleSelectAllBannerSize()}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                checked={bannerSize?.length === bannerSizeOptions?.length}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                Select All
                                                                            </Checkbox>
                                                                        </div>

                                                                        {menu}
                                                                    </>
                                                                )}
                                                            >
                                                                {[
                                                                    ...filterBannerSize?.filter(option => bannerSize?.includes(option.value)), // Checked options first
                                                                    ...filterBannerSize?.filter(option => !bannerSize?.includes(option.value)) // Unchecked options next
                                                                ].map(option => (
                                                                    <Option key={option.value} value={option.value}>
                                                                        <div
                                                                            onClick={() => handleBannerSize(option.value)}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                checked={bannerSize?.includes(option.value)}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                {option.label}
                                                                            </Checkbox>
                                                                        </div>
                                                                    </Option>
                                                                ))}
                                                            </Select>


                                                        </div>
                                                        <span className="error_content"> {bannerSizeIsRequiredError && <>Minimum 1 selection required</>}</span>
                                                    </div>
                                                }


                                                <div className="form_content_block--group  hide_caret_after_select_value">
                                                    <label className="form_label">Interstitial Match * </label>
                                                    <Select
                                                        showSearch
                                                        className='form_select basic no_search'
                                                        placeholder="-Select-"
                                                        optionFilterProp="label"
                                                        onChange={onChangeInterstitialMatch}
                                                        value={interstitialMatch}
                                                        options={interstitialMatchOptions}
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                    <label className="form_label">Locations </label>
                                                    <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                        <Select
                                                            id="countryList"
                                                            value={countryList}
                                                            // disabled={true}
                                                            popupClassName='diff_select_d2 --full'
                                                            // open={true}
                                                            showSearch={false}
                                                            placeholder='- Select -'
                                                            className="form_select basic"
                                                            mode='multiple'
                                                            maxTagCount='responsive'
                                                            dropdownRender={menu => (
                                                                <>
                                                                    <div className="custom_inside_searchbar_d2">
                                                                        <Input placeholder="Search" value={searchCountryList} onChange={handleSearchCountryList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                    </div>
                                                                    <div className='select_all_d2'
                                                                        onClick={() => handleSelectAllCountryList()}>
                                                                        <Checkbox
                                                                            checked={countryList?.length === countryListOptions?.length}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        >
                                                                            Select All
                                                                        </Checkbox>
                                                                    </div>

                                                                    {menu}
                                                                </>
                                                            )}
                                                        >
                                                            {[
                                                                ...filterCountryList?.filter(option => countryList?.includes(option.value)), // Checked options first
                                                                ...filterCountryList?.filter(option => !countryList?.includes(option.value)) // Unchecked options next
                                                            ].map(option => (
                                                                <Option key={option.value} value={option.value}>
                                                                    <div
                                                                        onClick={() => handleCountryList(option.value)}
                                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                                    >
                                                                        <Checkbox
                                                                            checked={countryList?.includes(option.value)}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        >
                                                                            {option.label}
                                                                        </Checkbox>
                                                                    </div>
                                                                </Option>
                                                            ))}
                                                        </Select>
                                                    </div>
                                                    <span className="error_content"> </span>
                                                </div>
                                                <div className="form_content_block--group  hide_caret_after_select_value" ref={referrerListRef}>
                                                    <Row gutter={20}>
                                                        <Col span={7}>
                                                            <label className="form_label">Referrer List Mode * </label>
                                                            <Select
                                                                showSearch
                                                                className='form_select basic no_search'
                                                                placeholder="-Select-"
                                                                optionFilterProp="label"
                                                                onChange={onChangeReferrerListMode}
                                                                value={referrerListMode}
                                                                options={referrerListModeOptions}
                                                            />
                                                            <span className="error_content"> </span>
                                                        </Col>
                                                        <Col span={17}>
                                                            <label className="form_label">Referrer List * </label>

                                                            <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                                {referrerListMode === "DISABLED" ?
                                                                    <Select
                                                                        id="referrerList"
                                                                        disabled={true}
                                                                        popupClassName='diff_select_d2 --half'
                                                                        // open={true}
                                                                        showSearch={false}
                                                                        placeholder='- Select -'
                                                                        className="form_select basic"
                                                                    />
                                                                    :
                                                                    <Select
                                                                        id="referrerList"
                                                                        value={referrerList}
                                                                        // disabled={true}
                                                                        popupClassName='diff_select_d2 --half'
                                                                        // open={true}
                                                                        showSearch={false}
                                                                        placeholder='- Select -'
                                                                        className={referrerListIsRequiredError ? "form_select basic error" : "form_select basic"}
                                                                        mode='multiple'
                                                                        maxTagCount='responsive'
                                                                        dropdownRender={menu => (
                                                                            <>
                                                                                <div className="custom_inside_searchbar_d2">
                                                                                    <Input placeholder="Search" value={searchReferrerList} onChange={handleSearchReferrerList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                </div>
                                                                                <div className='select_all_d2' onClick={() => handleSelectAllReferrerList()}>
                                                                                    <Checkbox checked={referrerList?.length === referrerListOptions?.length} onClick={(e) => e.stopPropagation()}>
                                                                                        Select All
                                                                                    </Checkbox>
                                                                                </div>
                                                                                {menu}
                                                                            </>
                                                                        )}
                                                                    >
                                                                        {[
                                                                            ...filterReferrerList?.filter(option => referrerList?.includes(option.value)), // Checked options first
                                                                            ...filterReferrerList?.filter(option => !referrerList?.includes(option.value)) // Unchecked options next
                                                                        ].map(option => (

                                                                            <Option key={option.value} value={option.value}>
                                                                                <div
                                                                                    onClick={() => handleReferrerList(option.value)}
                                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                                >
                                                                                    <Checkbox
                                                                                        checked={referrerList?.includes(option.value)}
                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                    >
                                                                                        {option.label}
                                                                                    </Checkbox>
                                                                                </div>
                                                                            </Option>

                                                                        ))}
                                                                    </Select>
                                                                }
                                                            </div>
                                                            <span className="error_content"> {referrerListIsRequiredError && referrerListMode !== "DISABLED" && <>Minimum 1 selection is required</>}
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className="form_content_block--group  hide_caret_after_select_value">
                                                    <Row gutter={20}>
                                                        <Col span={7}>
                                                            <label className="form_label">App List Mode * </label>
                                                            <Select
                                                                showSearch
                                                                className='form_select basic no_search'
                                                                placeholder="-Select-"
                                                                optionFilterProp="label"
                                                                onChange={onChangeAppListMode}
                                                                value={appListMode}
                                                                options={appListModeOptions}
                                                            />
                                                            <span className="error_content"> </span>
                                                        </Col>
                                                        <Col span={17}>
                                                            <label className="form_label">App List * </label>

                                                            <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                                {appListMode === "DISABLED" ?
                                                                    <Select
                                                                        id="referrerList"
                                                                        disabled={true}
                                                                        popupClassName='diff_select_d2 --full'
                                                                        // open={true}
                                                                        showSearch={false}
                                                                        placeholder='- Select -'
                                                                        className="form_select basic"
                                                                    />
                                                                    :
                                                                    <Select
                                                                        id="appList"
                                                                        value={appList}
                                                                        // disabled={true}
                                                                        popupClassName='diff_select_d2 --half'
                                                                        // open={true}
                                                                        showSearch={false}
                                                                        placeholder='- Select -'
                                                                        className={appListIsRequiredError ? "form_select basic error" : "form_select basic"}
                                                                        mode='multiple'
                                                                        maxTagCount='responsive'
                                                                        dropdownRender={menu => (
                                                                            <>
                                                                                <div className="custom_inside_searchbar_d2">
                                                                                    <Input placeholder="Search" value={searchAppList} onChange={handleSearchAppList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                </div>
                                                                                <div className='select_all_d2'
                                                                                    onClick={() => handleSelectAllAppList()}
                                                                                >
                                                                                    <Checkbox
                                                                                        checked={appList?.length === appListOptions?.length}
                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                    >
                                                                                        Select All
                                                                                    </Checkbox>
                                                                                </div>

                                                                                {menu}
                                                                            </>
                                                                        )}
                                                                    >
                                                                        {[
                                                                            ...filterAppList?.filter(option => appList?.includes(option.value)), // Checked options first
                                                                            ...filterAppList?.filter(option => !appList?.includes(option.value)) // Unchecked options next
                                                                        ].map(option => (
                                                                            <Option key={option.value} value={option.value}>
                                                                                <div
                                                                                    onClick={() => handleAppList(option.value)}
                                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                                >
                                                                                    <Checkbox
                                                                                        checked={appList?.includes(option.value)}
                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                    >
                                                                                        {option.label}
                                                                                    </Checkbox>
                                                                                </div>
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                }
                                                            </div>
                                                            <span className="error_content"> {appListIsRequiredError && appListMode !== "DISABLED" && <>Minimum 1 selection is required</>}
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className="form_content_block--group  hide_caret_after_select_value" ref={deviceIfaListRef}>
                                                    <Row gutter={20}>
                                                        <Col span={7}>
                                                            <label className="form_label">Device Ifa List Mode </label>
                                                            <Select
                                                                showSearch
                                                                className='form_select basic no_search'
                                                                placeholder="-Select-"
                                                                optionFilterProp="label"
                                                                onChange={onChangeDeviceIfaListMode}
                                                                value={deviceIfaListMode}
                                                                options={deviceIfaListModeOptions}
                                                            />
                                                            <span className="error_content"> </span>
                                                        </Col>
                                                        <Col span={17} className='disabled_ant_select_d2'>
                                                            <label className="form_label">Device Ifa Lists </label>
                                                            <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                                {deviceIfaListMode === "DISABLED" ?
                                                                    <Select
                                                                        id="referrerList"
                                                                        disabled={true}
                                                                        popupClassName='diff_select_d2 --full'
                                                                        // open={true}
                                                                        showSearch={false}
                                                                        placeholder='- Select -'
                                                                        className="form_select basic"
                                                                    />
                                                                    :
                                                                    <Select
                                                                        id="deviceIfaList"
                                                                        value={deviceIfaList}
                                                                        // disabled={true}
                                                                        popupClassName='diff_select_d2 --half'
                                                                        // open={true}
                                                                        showSearch={false}
                                                                        placeholder='- Select -'
                                                                        className={deviceIfaListIsRequiredError ? "form_select basic error" : "form_select basic"}
                                                                        mode='multiple'
                                                                        maxTagCount='responsive'
                                                                        dropdownRender={menu => (
                                                                            <>
                                                                                <div className="custom_inside_searchbar_d2">
                                                                                    <Input placeholder="Search" value={searchDeviceIfaList} onChange={handleSearchDeviceIfaList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                </div>
                                                                                <div className='select_all_d2'
                                                                                    onClick={() => handleSelectAllDeviceIfaList()}
                                                                                >
                                                                                    <Checkbox
                                                                                        checked={deviceIfaList?.length === deviceIfaListOptions?.length}
                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                    >
                                                                                        Select All
                                                                                    </Checkbox>
                                                                                </div>

                                                                                {menu}
                                                                            </>
                                                                        )}
                                                                    >
                                                                        {[
                                                                            ...filterDeviceIfaList?.filter(option => deviceIfaList?.includes(option.value)), // Checked options first
                                                                            ...filterDeviceIfaList?.filter(option => !deviceIfaList?.includes(option.value)) // Unchecked options next
                                                                        ].map(option => (
                                                                            <Option key={option.value} value={option.value}>
                                                                                <div
                                                                                    onClick={() => handleDeviceIfaList(option.value)}
                                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                                >
                                                                                    <Checkbox
                                                                                        checked={deviceIfaList?.includes(option.value)}
                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                    >
                                                                                        {option.label}
                                                                                    </Checkbox>
                                                                                </div>
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                }
                                                            </div>
                                                            <span className="error_content"> {deviceIfaListIsRequiredError && deviceIfaListMode !== "DISABLED" && <>Minimum 1 selection is required</>}
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                {/* <div className="form_content_block--group  hide_caret_after_select_value">
                                                <label className="form_label">Device Ifa Retargeting Lists </label>
                                                <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                    <Select
                                                        id="adcodeSelect"
                                                        value={filterApply.publisher}
                                                        popupClassName='diff_select_d2 --full'
                                                        // open={true}
                                                        showSearch={false}
                                                        placeholder='- Select -'
                                                        className="form_select basic"
                                                        mode='multiple'
                                                        maxTagCount='responsive'
                                                        dropdownRender={menu => (
                                                            <>
                                                                <div className="custom_inside_searchbar_d2">
                                                                    <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                </div>
                                                                {menu}
                                                            </>
                                                        )}
                                                    >
                                                        {filteredOptions.map(option => (
                                                            <Option key={option.value} value={option.value}>
                                                                <div
                                                                    onClick={() => handleFilterApply("publisher", option.value)}
                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                >
                                                                    <Checkbox
                                                                        checked={filterApply.publisher.includes(option.value)}
                                                                        onClick={(e) => e.stopPropagation()}
                                                                    >
                                                                        {option.label}
                                                                    </Checkbox>
                                                                </div>
                                                            </Option>
                                                        ))}
                                                    </Select>
                                                </div>
                                                <span className="error_content"> </span>
                                            </div>
                                            <div className="form_content_block--group  hide_caret_after_select_value">
                                                <Row gutter={20}>
                                                    <Col span={7}>
                                                        <label className="form_label">Publisher Id List Mode </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17} className='disabled_ant_select_d2'>
                                                        <label className="form_label">Publisher Id Lists </label>
                                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                            <Select
                                                                id="adcodeSelect"
                                                                value={filterApply.publisher}
                                                                disabled={true}
                                                                popupClassName='diff_select_d2 --half'
                                                                // open={true}
                                                                showSearch={false}
                                                                // placeholder='- Select -'
                                                                className="form_select basic"
                                                                mode='multiple'
                                                                maxTagCount='responsive'
                                                                dropdownRender={menu => (
                                                                    <>
                                                                        <div className="custom_inside_searchbar_d2">
                                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                        </div>
                                                                        {menu}
                                                                    </>
                                                                )}
                                                            >
                                                                {filteredOptions.map(option => (
                                                                    <Option key={option.value} value={option.value}>
                                                                        <div
                                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                checked={filterApply.publisher.includes(option.value)}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                {option.label}
                                                                            </Checkbox>
                                                                        </div>
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div> */}
                                                {/* <div className="form_content_block--group  hide_caret_after_select_value">
                                                <Row gutter={20}>
                                                    <Col span={7}>
                                                        <label className="form_label">Site Id List Mode </label>
                                                        <Select
                                                            showSearch
                                                            className='form_select basic no_search'
                                                            placeholder="-Select-"
                                                            optionFilterProp="label"
                                                            onChange={onChange}
                                                            onSearch={onSearch}
                                                            options={[
                                                                {
                                                                    value: 'jack',
                                                                    label: 'Jack',
                                                                },
                                                                {
                                                                    value: 'lucy',
                                                                    label: 'Lucy',
                                                                },
                                                                {
                                                                    value: 'tom',
                                                                    label: 'Tom',
                                                                },
                                                            ]}
                                                        />
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                    <Col span={17} className='disabled_ant_select_d2'>
                                                        <label className="form_label">Site Id Lists </label>
                                                        <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                            <Select
                                                                id="adcodeSelect"
                                                                value={filterApply.publisher}
                                                                disabled={true}
                                                                popupClassName='diff_select_d2 --half'
                                                                // open={true}
                                                                showSearch={false}
                                                                // placeholder='- Select -'
                                                                className="form_select basic"
                                                                mode='multiple'
                                                                maxTagCount='responsive'
                                                                dropdownRender={menu => (
                                                                    <>
                                                                        <div className="custom_inside_searchbar_d2">
                                                                            <Input placeholder="Search" value={searchValue} onChange={handleSearch} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                        </div>
                                                                        {menu}
                                                                    </>
                                                                )}
                                                            >
                                                                {filteredOptions.map(option => (
                                                                    <Option key={option.value} value={option.value}>
                                                                        <div
                                                                            onClick={() => handleFilterApply("publisher", option.value)}
                                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                                        >
                                                                            <Checkbox
                                                                                checked={filterApply.publisher.includes(option.value)}
                                                                                onClick={(e) => e.stopPropagation()}
                                                                            >
                                                                                {option.label}
                                                                            </Checkbox>
                                                                        </div>
                                                                    </Option>
                                                                ))}
                                                            </Select>
                                                        </div>
                                                        <span className="error_content"> </span>
                                                    </Col>
                                                </Row>
                                            </div> */}
                                                <div className="form_content_block--group  hide_caret_after_select_value">
                                                    <Row gutter={20}>
                                                        <Col span={7}>
                                                            <label className="form_label">App Id List Mode </label>
                                                            <Select
                                                                showSearch
                                                                className='form_select basic no_search'
                                                                placeholder="-Select-"
                                                                optionFilterProp="label"
                                                                onChange={onChangeAppIdListMode}
                                                                value={appIdListMode}
                                                                options={appIdListModeOptions}
                                                            />
                                                            <span className="error_content"> </span>
                                                        </Col>
                                                        <Col span={17} className='disabled_ant_select_d2'>
                                                            <label className="form_label">App Id Lists </label>
                                                            <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                                {
                                                                    appIdListMode === "DISABLED" ?
                                                                        <Select
                                                                            id="referrerList"
                                                                            disabled={true}
                                                                            popupClassName='diff_select_d2 --full'
                                                                            // open={true}
                                                                            showSearch={false}
                                                                            placeholder='- Select -'
                                                                            className="form_select basic"
                                                                        />
                                                                        :

                                                                        <Select
                                                                            id="appIdList"
                                                                            value={appIdList}
                                                                            // disabled={true}
                                                                            popupClassName='diff_select_d2 --half'
                                                                            // open={true}
                                                                            showSearch={false}
                                                                            placeholder='- Select -'
                                                                            className="form_select basic"
                                                                            mode='multiple'
                                                                            maxTagCount='responsive'
                                                                            dropdownRender={menu => (
                                                                                <>
                                                                                    <div className="custom_inside_searchbar_d2">
                                                                                        <Input placeholder="Search" value={searchAppIdList} onChange={handleSearchAppIdList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                    </div>
                                                                                    <div className='select_all_d2'
                                                                                        onClick={() => handleSelectAllAppIdList()}
                                                                                    >
                                                                                        <Checkbox
                                                                                            checked={appIdList?.length === appIdListOptions?.length}
                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                        >
                                                                                            Select All
                                                                                        </Checkbox>
                                                                                    </div>

                                                                                    {menu}
                                                                                </>
                                                                            )}
                                                                        >
                                                                            {[
                                                                                ...filterAppIdList?.filter(option => appIdList?.includes(option.value)), // Checked options first
                                                                                ...filterAppIdList?.filter(option => !appIdList?.includes(option.value)) // Unchecked options next
                                                                            ].map(option => (
                                                                                <Option key={option.value} value={option.value}>
                                                                                    <div
                                                                                        onClick={() => handleAppIdList(option.value)}
                                                                                        style={{ display: 'flex', alignItems: 'center' }}
                                                                                    >
                                                                                        <Checkbox
                                                                                            checked={appIdList?.includes(option.value)}
                                                                                            onClick={(e) => e.stopPropagation()}
                                                                                        >
                                                                                            {option.label}
                                                                                        </Checkbox>
                                                                                    </div>
                                                                                </Option>
                                                                            ))}
                                                                        </Select>
                                                                }
                                                            </div>
                                                            <span className="error_content"> </span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className="form_content_block--group  hide_caret_after_select_value" ref={ipListRef}>
                                                    <Row gutter={20}>
                                                        <Col span={7}>
                                                            <label className="form_label">IP List Mode </label>
                                                            <Select
                                                                showSearch
                                                                className='form_select basic no_search'
                                                                placeholder="-Select-"
                                                                optionFilterProp="label"
                                                                onChange={onChangeIpListMode}
                                                                value={ipListMode}
                                                                options={ipListModeOptions}
                                                            />
                                                            <span className="error_content"> </span>
                                                        </Col>
                                                        <Col span={17} className='disabled_ant_select_d2'>
                                                            <label className="form_label">IP Lists </label>
                                                            <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                                {ipListMode === "DISABLED" ?
                                                                    <Select
                                                                        id="referrerList"
                                                                        disabled={true}
                                                                        popupClassName='diff_select_d2 --full'
                                                                        // open={true}
                                                                        showSearch={false}
                                                                        placeholder='- Select -'
                                                                        className="form_select basic"
                                                                    />
                                                                    :

                                                                    <Select
                                                                        id="ipList"
                                                                        value={ipList}
                                                                        // disabled={true}
                                                                        popupClassName='diff_select_d2 --half'
                                                                        // open={true}
                                                                        showSearch={false}
                                                                        placeholder='- Select -'
                                                                        className={ipListIsRequiredError ? "form_select basic error" : "form_select basic"}
                                                                        mode='multiple'
                                                                        maxTagCount='responsive'
                                                                        dropdownRender={menu => (
                                                                            <>
                                                                                <div className="custom_inside_searchbar_d2">
                                                                                    <Input placeholder="Search" value={searchIpList} onChange={handleSearchIpList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                </div>
                                                                                <div className='select_all_d2'
                                                                                    onClick={() => handleSelectAllIpList()}
                                                                                >
                                                                                    <Checkbox
                                                                                        checked={ipList?.length === ipListOptions?.length}
                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                    >
                                                                                        Select All
                                                                                    </Checkbox>
                                                                                </div>

                                                                                {menu}
                                                                            </>
                                                                        )}
                                                                    >
                                                                        {[
                                                                            ...filterIpList?.filter(option => ipList?.includes(option.value)), // Checked options first
                                                                            ...filterIpList?.filter(option => !ipList?.includes(option.value)) // Unchecked options next
                                                                        ].map(option => (
                                                                            <Option key={option.value} value={option.value}>
                                                                                <div
                                                                                    onClick={() => handleIpList(option.value)}
                                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                                >
                                                                                    <Checkbox
                                                                                        checked={ipList?.includes(option.value)}
                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                    >
                                                                                        {option.label}
                                                                                    </Checkbox>
                                                                                </div>
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                }
                                                            </div>
                                                            <span className="error_content"> {ipListIsRequiredError && ipListMode !== "DISABLED" && <>Minimum 1 selection is required</>}
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className="form_content_block--group  hide_caret_after_select_value">
                                                    <Row gutter={20}>
                                                        <Col span={7}>
                                                            <label className="form_label">Tag Id List Mode </label>
                                                            <Select
                                                                showSearch
                                                                className='form_select basic no_search'
                                                                placeholder="-Select-"
                                                                optionFilterProp="label"
                                                                onChange={onChangeTagListMode}
                                                                value={tagListMode}
                                                                options={tagListModeOptions}
                                                            />
                                                            <span className="error_content"> </span>
                                                        </Col>
                                                        <Col span={17} className='disabled_ant_select_d2'>
                                                            <label className="form_label">Tag Id Lists </label>
                                                            <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                                {tagListMode === "DISABLED" ?
                                                                    <Select
                                                                        id="referrerList"
                                                                        disabled={true}
                                                                        popupClassName='diff_select_d2 --full'
                                                                        // open={true}
                                                                        showSearch={false}
                                                                        placeholder='- Select -'
                                                                        className="form_select basic"
                                                                    />
                                                                    :
                                                                    <Select
                                                                        id="tagList"
                                                                        value={tagList}
                                                                        // disabled={true}
                                                                        popupClassName='diff_select_d2 --half'
                                                                        // open={true}
                                                                        showSearch={false}
                                                                        placeholder='- Select -'
                                                                        className={tagListIsRequiredError ? "form_select basic error" : "form_select basic"}
                                                                        mode='multiple'
                                                                        maxTagCount='responsive'
                                                                        dropdownRender={menu => (
                                                                            <>
                                                                                <div className="custom_inside_searchbar_d2">
                                                                                    <Input placeholder="Search" value={searchTagList} onChange={handleSearchTagList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                                                </div>
                                                                                <div className='select_all_d2'
                                                                                    onClick={() => handleSelectAllTagList()}
                                                                                >
                                                                                    <Checkbox
                                                                                        checked={tagList?.length === tagListOptions?.length}
                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                    >
                                                                                        Select All
                                                                                    </Checkbox>
                                                                                </div>

                                                                                {menu}
                                                                            </>
                                                                        )}
                                                                    >
                                                                        {[
                                                                            ...filterTagList?.filter(option => tagList?.includes(option.value)), // Checked options first
                                                                            ...filterTagList?.filter(option => !tagList?.includes(option.value)) // Unchecked options next
                                                                        ].map(option => (
                                                                            <Option key={option.value} value={option.value}>
                                                                                <div
                                                                                    onClick={() => handleTagList(option.value)}
                                                                                    style={{ display: 'flex', alignItems: 'center' }}
                                                                                >
                                                                                    <Checkbox
                                                                                        checked={tagList?.includes(option.value)}
                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                    >
                                                                                        {option.label}
                                                                                    </Checkbox>
                                                                                </div>
                                                                            </Option>
                                                                        ))}
                                                                    </Select>
                                                                }
                                                            </div>
                                                            <span className="error_content"> {tagListIsRequiredError && tagListMode !== "DISABLED" && <>Minimum 1 selection is required</>}
                                                            </span>
                                                        </Col>
                                                    </Row>
                                                </div>
                                                <div className="form_content_block--group  hide_caret_after_select_value" ref={omidPartnersListRef}>
                                                    <label className="form_label">OMID Partners List Mode </label>
                                                    <Select
                                                        showSearch
                                                        className='form_select basic no_search'
                                                        placeholder="-Select-"
                                                        optionFilterProp="label"
                                                        onChange={onChangeOmidPartnersListMode}
                                                        value={omidPartnersListMode}
                                                        options={omidPartnersListModeOptions}
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                    <label className="form_label">OMID Partners</label>
                                                    {omidPartnersListMode === "DISABLED" ?
                                                        <Input className='form_control basic form_control_h --80' disabled autocomplete="off"

                                                        />
                                                        :
                                                        <TextArea autocomplete="off"
                                                            className={omidPartnersListIsRequiredError ? 'form_control basic form_control_h --80 textarea_paddingY_d2 error' : 'form_control basic form_control_h --80 textarea_paddingY_d2'}
                                                            onChange={onChangeOmidPartnersList}
                                                            onBlur={onBlurOmidPartnersList}
                                                            value={omidPartnersList}
                                                        />
                                                    }
                                                    <span className="error_content"> {omidPartnersListIsRequiredError && omidPartnersListMode !== "DISABLED" && <>Value can not be empty</>}
                                                    </span>
                                                </div>


                                                <div className="form_content_block--group  hide_caret_after_select_value" ref={displayManagersListRef}>
                                                    <label className="form_label">Display Managers List Mode </label>
                                                    <Select
                                                        showSearch
                                                        className='form_select basic no_search'
                                                        placeholder="-Select-"
                                                        optionFilterProp="label"
                                                        onChange={onChangeDisplayManagersListMode}
                                                        value={displayManagersListMode}
                                                        options={displayManagersListModeOptions}
                                                    />
                                                    <span className="error_content"> </span>
                                                </div>
                                                <div className="form_content_block--group hide_caret_after_select_value">
                                                    <label className="form_label">Display Managers</label>
                                                    {displayManagersListMode === "DISABLED" ?
                                                        <Input className='form_control basic form_control_h --80' disabled autocomplete="off"

                                                        />
                                                        :
                                                        <TextArea autocomplete="off"
                                                            className={displayManagersListIsRequiredError ? 'form_control basic form_control_h --80 textarea_paddingY_d2 error' : 'form_control basic form_control_h --80 textarea_paddingY_d2'}
                                                            onChange={onChangeDisplayManagersList}
                                                            value={displayManagersList}
                                                            onBlur={onBlurDisplayManagersList}
                                                        />
                                                    }
                                                    <span className="error_content"> {displayManagersListIsRequiredError && displayManagersListMode !== "DISABLED" && <>Value can not be empty</>}
                                                    </span>
                                                </div>


                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Devices</label>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <div className="form_content_block--group  hide_caret_after_select_value">
                                            <label className="form_label">Operating Systems </label>
                                            <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                <TreeSelect {...tPropsOs} className="form_select basic tree_height_d2" maxTagCount={6} popupClassName='diff_tree_select_d2' />
                                            </div>
                                            <span className="error_content"> </span>
                                        </div>
                                        <div className="form_content_block--group  hide_caret_after_select_value">
                                            <label className="form_label">Browsers </label>
                                            <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                <Select
                                                    id="browserList"
                                                    value={browserList}
                                                    // disabled={true}
                                                    popupClassName='diff_select_d2 --full'
                                                    // open={true}
                                                    showSearch={false}
                                                    placeholder='- Select -'
                                                    className="form_select basic"
                                                    mode='multiple'
                                                    maxTagCount='responsive'
                                                    dropdownRender={menu => (
                                                        <>
                                                            <div className="custom_inside_searchbar_d2">
                                                                <Input placeholder="Search" value={searchBrowswerList} onChange={handleSearchBrowserList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                            </div>
                                                            <div className='select_all_d2'
                                                                onClick={() => handleSelectAllBrowserList()}
                                                            >
                                                                <Checkbox
                                                                    checked={browserList?.length === browserListOptions?.length}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    Select All
                                                                </Checkbox>
                                                            </div>

                                                            {menu}
                                                        </>
                                                    )}
                                                >
                                                    {[
                                                        ...filterBrowserList?.filter(option => browserList?.includes(option.value)), // Checked options first
                                                        ...filterBrowserList?.filter(option => !browserList?.includes(option.value)) // Unchecked options next
                                                    ].map(option => (
                                                        <Option key={option.value} value={option.value}>
                                                            <div
                                                                onClick={() => handleBrowserList(option.value)}
                                                                style={{ display: 'flex', alignItems: 'center' }}
                                                            >
                                                                <Checkbox
                                                                    checked={browserList?.includes(option.value)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    {option.label}
                                                                </Checkbox>
                                                            </div>
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>
                                            <span className="error_content"> </span>
                                        </div>
                                        <div className="form_content_block--group">
                                            <div className="primary_checkbox">
                                                <Checkbox id="checkboxAutoIncludeNewBrowser" name="checkboxAutoIncludeNewBrowser"
                                                    checked={checkboxAutoIncludeNewBrowser}
                                                    onChange={onChangeCheckboxAutoIncludeNewBrowser}
                                                >
                                                    <span className="form_label">
                                                        Auto-include new browser versions
                                                    </span>
                                                </Checkbox>
                                            </div>
                                        </div>
                                        <div className="form_content_block--group  hide_caret_after_select_value" ref={deviceListRef}>
                                            <label className="form_label">Device Types * </label>
                                            <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                <Select
                                                    id="deviceList"
                                                    value={deviceList}
                                                    // disabled={true}
                                                    popupClassName='diff_select_d2 --full'
                                                    showSearch={false}
                                                    placeholder='- Select -'
                                                    className={deviceListIsRequiredError ? "form_select basic error" : "form_select basic"}
                                                    mode='multiple'
                                                    maxTagCount='responsive'
                                                    dropdownRender={menu => (
                                                        <>
                                                            <div className="custom_inside_searchbar_d2">
                                                                <Input placeholder="Search" value={searchDeviceList} onChange={handleSearchDeviceList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                            </div>
                                                            <div className='select_all_d2'
                                                                onClick={() => handleSelectAllDeviceList()}
                                                            >
                                                                <Checkbox
                                                                    checked={deviceList?.length === deviceListOptions?.length}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    Select All
                                                                </Checkbox>
                                                            </div>

                                                            {menu}
                                                        </>
                                                    )}
                                                >
                                                    {[
                                                        ...filterDeviceList?.filter(option => deviceList?.includes(option.value)), // Checked options first
                                                        ...filterDeviceList?.filter(option => !deviceList?.includes(option.value)) // Unchecked options next
                                                    ].map(option => (
                                                        <Option key={option.value} value={option.value}>
                                                            <div
                                                                onClick={() => handleDeviceList(option.value)}
                                                                style={{ display: 'flex', alignItems: 'center' }}
                                                            >
                                                                <Checkbox
                                                                    checked={deviceList?.includes(option.value)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    {option.label}
                                                                </Checkbox>
                                                            </div>
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>
                                            <span className="error_content"> {deviceListIsRequiredError && <>Minimum 1 selection required</>}</span>
                                        </div>
                                        <div className="form_content_block--group  hide_caret_after_select_value">
                                            <label className="form_label">Device Brand Models </label>
                                            <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                <Select
                                                    id="deviceBrandList"
                                                    value={deviceBrandList}
                                                    // disabled={true}
                                                    popupClassName='diff_select_d2 --full'
                                                    showSearch={false}
                                                    placeholder='- Select -'
                                                    className="form_select basic"
                                                    mode='multiple'
                                                    maxTagCount='responsive'
                                                    dropdownRender={menu => (
                                                        <>
                                                            <div className="custom_inside_searchbar_d2">
                                                                <Input placeholder="Search" value={searchDeviceBrandList} onChange={handleSearchDeviceBrandList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                            </div>
                                                            <div className='select_all_d2'
                                                                onClick={() => handleSelectAllDeviceBrandList()}
                                                            >
                                                                <Checkbox
                                                                    checked={deviceBrandList?.length === deviceBrandListOptions?.length}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    Select All
                                                                </Checkbox>
                                                            </div>

                                                            {menu}
                                                        </>
                                                    )}
                                                >
                                                    {[
                                                        ...filterDeviceBrandList?.filter(option => deviceBrandList?.includes(option.value)), // Checked options first
                                                        ...filterDeviceBrandList?.filter(option => !deviceBrandList?.includes(option.value)) // Unchecked options next
                                                    ].map(option => (
                                                        <Option key={option.value} value={option.value}>
                                                            <div
                                                                onClick={() => handleDeviceBrandList(option.value)}
                                                                style={{ display: 'flex', alignItems: 'center' }}
                                                            >
                                                                <Checkbox
                                                                    checked={deviceBrandList?.includes(option.value)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    {option.label}
                                                                </Checkbox>
                                                            </div>
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>
                                            <span className="error_content"> </span>
                                        </div>
                                        <div className="form_content_block--group  hide_caret_after_select_value">
                                            <label className="form_label">Connection Type </label>
                                            <div className='checkbox_value_select_d2'>
                                                {/* <Select
                                                id="connectionList"
                                                value={connectionList}
                                                // disabled={true}
                                                popupClassName='diff_select_d2 --full'
                                                showSearch={false}
                                                placeholder='- Select -'
                                                className="form_select basic"
                                                mode='multiple'
                                                maxTagCount='responsive'
                                                dropdownRender={menu => (
                                                    <>
                                                        <div className="custom_inside_searchbar_d2">
                                                            <Input placeholder="Search" value={searchConnectionList} onChange={handleSearchConnectionList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                        </div>
                                                        <div
                                                            onClick={() => handleSelectAllConnectionList()}
                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                        >
                                                            <Checkbox
                                                                checked={connectionList?.length === connectionListOptions?.length}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                Select All
                                                            </Checkbox>
                                                        </div>

                                                        {menu}
                                                    </>
                                                )}
                                            >
                                                {filterConnectionList.map(option => (
                                                    <Option key={option.value} value={option.value}>
                                                        <div
                                                            onClick={() => handleConnectionList(option.value)}
                                                            style={{ display: 'flex', alignItems: 'center' }}
                                                        >
                                                            <Checkbox
                                                                checked={connectionList.includes(option.value)}
                                                                onClick={(e) => e.stopPropagation()}
                                                            >
                                                                {option.label}
                                                            </Checkbox>
                                                        </div>
                                                    </Option>
                                                ))}
                                            </Select> */}
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChangeConnectionList}
                                                    value={connectionList}
                                                    options={connectionListOptions}
                                                />
                                            </div>
                                            <span className="error_content"> </span>
                                        </div>
                                        <div className="form_content_block--group  hide_caret_after_select_value mb-0">
                                            <label className="form_label">Carriers </label>
                                            <div className='checkbox_value_select_d2 multi_select_tag_d2'>
                                                <Select
                                                    id="carriersList"
                                                    value={carriersList}
                                                    // disabled={true}
                                                    popupClassName='diff_select_d2 --full'
                                                    showSearch={false}
                                                    placeholder='- Select -'
                                                    className="form_select basic"
                                                    mode='multiple'
                                                    maxTagCount='responsive'
                                                    dropdownRender={menu => (
                                                        <>
                                                            <div className="custom_inside_searchbar_d2">
                                                                <Input placeholder="Search" value={searchCarriersList} onChange={handleSearchCarriersList} prefix={<SearchOutlined className="search_icon_d2" />} allowClear />
                                                            </div>
                                                            <div className='select_all_d2'
                                                                onClick={() => handleSelectAllCarriersList()}
                                                            >
                                                                <Checkbox
                                                                    checked={carriersList?.length === carriersListOptions?.length}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    Select All
                                                                </Checkbox>
                                                            </div>

                                                            {menu}
                                                        </>
                                                    )}
                                                >
                                                    {[
                                                        ...filterCarriersList?.filter(option => carriersList?.includes(option.value)), // Checked options first
                                                        ...filterCarriersList?.filter(option => !carriersList?.includes(option.value)) // Unchecked options next
                                                    ].map(option => (
                                                        <Option key={option.value} value={option.value}>
                                                            <div
                                                                onClick={() => handleCarriersList(option.value)}
                                                                style={{ display: 'flex', alignItems: 'center' }}
                                                            >
                                                                <Checkbox
                                                                    checked={carriersList?.includes(option.value)}
                                                                    onClick={(e) => e.stopPropagation()}
                                                                >
                                                                    {option.label}
                                                                </Checkbox>
                                                            </div>
                                                        </Option>
                                                    ))}
                                                </Select>
                                            </div>
                                            <span className="error_content"> </span>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Seller</label>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container" ref={sellerRef}>
                                        <div className="form_content_block--group  hide_caret_after_select_value">
                                            <label className="form_label">Send Seller Data * </label>
                                            <Select
                                                showSearch
                                                className='form_select basic no_search'
                                                placeholder="-Select-"
                                                optionFilterProp="label"
                                                onChange={onChangeSellertMode}
                                                value={sellerMode}
                                                options={sellerModeOptions}
                                            />
                                            <span className="error_content"> </span>
                                        </div>
                                        <Row gutter={16}>
                                            <Col span={12}>
                                                <div className="form_content_block--group mb_0">
                                                    <label className="form_label">Min Supply Chain Length</label>
                                                    <Input className='form_control basic' autocomplete="off"
                                                        value={minSupplyChain}
                                                        onChange={onChangeMinSupplyChain} />
                                                </div>
                                                <span className="error_content"></span>
                                            </Col>
                                            <Col span={12}>
                                                <div className="form_content_block--group mb_0">
                                                    <label className="form_label">Max Supply Chain Length</label>
                                                    <Input className='form_control basic' autocomplete="off"
                                                        value={maxSupplyChain}
                                                        onChange={onChangeMaxSupplyChain}
                                                    />
                                                    <span className="error_content">{maxSupplyChainValueError && <>Min value must be less or equal to max</>}</span>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Filters</label>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <div className="form_content_block--group">
                                            <div className="primary_checkbox">
                                                <Checkbox id="checkboxNonEmptyReferer" name="checkboxNonEmptyReferer"
                                                    checked={checkboxNonEmptyReferer}
                                                    onChange={onChangeCheckboxNonEmptyReferer}
                                                >
                                                    <span className="form_label">
                                                        Non-Empty Referrer
                                                    </span>
                                                </Checkbox>
                                            </div>
                                        </div>
                                        <div className="form_content_block--group">
                                            <div className="primary_checkbox">
                                                <Checkbox id="checkboxRefererMatch" name="checkboxRefererMatch"
                                                    checked={checkboxRefererMatch}
                                                    onChange={onChangeCheckboxRefererMatch}>
                                                    <span className="form_label">
                                                        Referrer Match
                                                    </span>
                                                </Checkbox>
                                            </div>
                                        </div>
                                        <div className="form_content_block--group">
                                            <div className="primary_checkbox">
                                                <Checkbox id="checkboxNonEmptyApplication" name="checkboxNonEmptyApplication"
                                                    checked={checkboxNonEmptyApplication}
                                                    onChange={onChangeCheckboxNonEmptyApplication}
                                                >
                                                    <span className="form_label">
                                                        Non-Empty Application
                                                    </span>
                                                </Checkbox>
                                            </div>
                                        </div>
                                        <div className="form_content_block--group">
                                            <div className="primary_checkbox">
                                                <Checkbox id="checkboxAppBundleMatch" name="checkboxAppBundleMatch"
                                                    checked={checkboxAppBundleMatch}
                                                    onChange={onChangeCheckboxAppBundleMatch}
                                                >
                                                    <span className="form_label">
                                                        App Bundle Match
                                                    </span>
                                                </Checkbox>
                                            </div>
                                        </div>
                                        <div className="form_content_block--group">
                                            <div className="primary_checkbox">
                                                <Checkbox id="checkboxIPMatch" name="checkboxIPMatch"
                                                    checked={checkboxIPMatch}
                                                    onChange={onChangeCheckboxIPMatch}
                                                >
                                                    <span className="form_label">
                                                        IP Match
                                                    </span>
                                                </Checkbox>
                                            </div>
                                        </div>
                                        <div className="form_content_block--group">
                                            <div className="primary_checkbox">
                                                <Checkbox id="checkboxGeoLocationMatch" name="checkboxGeoLocationMatch"
                                                    checked={checkboxGeoLocationMatch}
                                                    onChange={onChangeCheckboxGeoLocationMatch}
                                                >
                                                    <span className="form_label">
                                                        Geo Location Match
                                                    </span>
                                                </Checkbox>
                                            </div>
                                        </div>
                                        <div className="form_content_block--group">
                                            <div className="primary_checkbox">
                                                <Checkbox id="checkboxValidUserAgent" name="checkboxValidUserAgent"
                                                    checked={checkboxValidUserAgent}
                                                    onChange={onChangeCheckboxValidUserAgent}
                                                >
                                                    <span className="form_label">
                                                        Valid User-Agent
                                                    </span>
                                                </Checkbox>
                                            </div>
                                        </div>
                                        <div className="form_content_block--group">
                                            <div className="primary_checkbox">
                                                <Checkbox id="checkboxUserAgentMatch" name="checkboxUserAgentMatch"
                                                    checked={checkboxUserAgentMatch}
                                                    onChange={onChangeCheckboxUserAgentMatch}
                                                >
                                                    <span className="form_label">
                                                        User-Agent Match
                                                    </span>
                                                </Checkbox>
                                            </div>
                                        </div>
                                        <div className="form_content_block--group">
                                            <div className="primary_checkbox">
                                                <Checkbox id="checkboxNonRepeatedImpressions" name="checkboxNonRepeatedImpressions"
                                                    checked={checkboxNonRepeatedImpressions}
                                                    onChange={onChangeCheckboxNonRepeatedImpressions}
                                                >
                                                    <span className="form_label">
                                                        Non-Repeated Impressions
                                                    </span>
                                                </Checkbox>
                                            </div>
                                        </div>
                                        <div className="form_content_block--group mb-0">
                                            <div className="primary_checkbox">
                                                <Checkbox id="checkboxDiscountedImpressions" name="checkboxDiscountedImpressions"
                                                    checked={checkboxDiscountedImpressions}
                                                    onChange={onChangeCheckboxDiscountedImpressions}
                                                >
                                                    <span className="form_label">
                                                        Discounted Impressions
                                                    </span>
                                                </Checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Ad Quality</label>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container " >
                                        <div className="form_content_block--group  hide_caret_after_select_value" ref={seatListRef}>
                                            <label className="form_label">Seat List Mode </label>
                                            <Select
                                                showSearch
                                                className='form_select basic no_search'
                                                placeholder="-Select-"
                                                optionFilterProp="label"
                                                onChange={onChangeSeatListMode}
                                                value={seatListMode}
                                                options={seatListModeOptions}
                                            />
                                            <span className="error_content"> </span>
                                        </div>
                                        <div className="form_content_block--group hide_caret_after_select_value">
                                            <label className="form_label">Seats</label>
                                            {seatListMode === "DISABLED" ?
                                                <Input className='form_control basic form_control_h --80' disabled autocomplete="off"

                                                />
                                                :
                                                <TextArea className={seatListIsRequiredError ? 'form_control basic form_control_h --80 textarea_paddingY_d2 error' : 'form_control basic form_control_h --80 textarea_paddingY_d2'} autocomplete="off"
                                                    onChange={onChangeSeatList}
                                                    value={seatList}
                                                    onBlur={onBlurSeatList}
                                                />
                                            }
                                            <span className="error_content"> {seatListIsRequiredError && seatListMode !== "DISABLED" && <>Value can not be empty</>}
                                            </span>
                                        </div>
                                        <div className="form_content_block--group  hide_caret_after_select_value" ref={creativeListRef}>
                                            <label className="form_label">Creative Id List Mode </label>
                                            <Select
                                                showSearch
                                                className='form_select basic no_search'
                                                placeholder="-Select-"
                                                optionFilterProp="label"
                                                onChange={onChangeCreativeListMode}
                                                value={creativeListMode}
                                                options={creativeListModeOptions}
                                            />
                                            <span className="error_content"> </span>
                                        </div>
                                        <div className="form_content_block--group hide_caret_after_select_value">
                                            <label className="form_label">Creative Ids</label>
                                            {creativeListMode === "DISABLED" ?
                                                <Input className='form_control basic form_control_h --80' disabled autocomplete="off"

                                                />
                                                :

                                                <TextArea className={creativeListIsRequiredError ? 'form_control basic form_control_h --80 textarea_paddingY_d2 error' : 'form_control basic form_control_h --80 textarea_paddingY_d2'} autocomplete="off"
                                                    onChange={onChangeCreativeList}
                                                    value={creativeList}
                                                    onBlur={onBlurCreativeList}
                                                />
                                            }
                                            <span className="error_content"> {creativeListIsRequiredError && creativeListMode !== "DISABLED" && <>Value can not be empty</>}
                                            </span>
                                        </div>

                                        <div className="form_content_block--group">
                                            <div className="primary_checkbox">
                                                <Checkbox id="checkboxCreativeSampling" name="checkboxCreativeSampling"
                                                    checked={checkboxCreativeSampling}
                                                    onChange={onChangeCheckboxCreativeSampling}
                                                >
                                                    <span className="form_label">
                                                        Creative Sampling
                                                    </span>
                                                </Checkbox>
                                            </div>
                                        </div>
                                        <div className="form_content_block--group  hide_caret_after_select_value">
                                            <label className="form_label">Creative Approval Mode  </label>
                                            <Select
                                                showSearch
                                                className='form_select basic no_search'
                                                placeholder="-Select-"
                                                optionFilterProp="label"
                                                value={creativeApprovalMode}
                                                options={creativeApprovalModeOptions}
                                                onChange={onChangeCreativeApprovalMode}
                                            />
                                            <span className="error_content"> </span>
                                        </div>
                                        <div className="form_content_block--group  hide_caret_after_select_value">
                                            <label className="form_label">Ad Quality System </label>
                                            {checkboxCreativeSampling ?
                                                <Select
                                                    showSearch
                                                    className='form_select basic no_search'
                                                    placeholder="-Select-"
                                                    optionFilterProp="label"
                                                    onChange={onChangeAdQualitySystem}
                                                    value={adQualitySystem}
                                                    options={adQualitySystemOptions}
                                                />
                                                :
                                                <Input className='form_control basic' autocomplete="off"
                                                    disabled
                                                />
                                            }
                                            <span className="error_content"> </span>
                                        </div>
                                        <div className="form_content_block--group hide_caret_after_select_value">
                                            <label className="form_label">Number of Daily Scans </label>
                                            {checkboxCreativeSampling ?
                                                <Input className={(dailyScansIsRequiredError || dailyScansValidError) ? 'form_control basic error' : 'form_control basic'} autocomplete="off"
                                                    value={dailyScans}
                                                    onChange={onChangeDailyScans}
                                                />
                                                :
                                                <Input className='form_control basic' autocomplete="off"
                                                    disabled
                                                />
                                            }
                                            <span className="error_content">
                                                {dailyScansValidError &&
                                                    <>Value must be between 10 and 10000</>
                                                }
                                                {dailyScansIsRequiredError &&
                                                    <>This field is required</>
                                                } </span>
                                        </div>
                                        <div className="form_content_block--group mb-0">
                                            <div className="primary_checkbox">

                                                <Checkbox id="checkboxNotifyProvider" name="checkboxNotifyProvider"
                                                    checked={checkboxNotifyProvider}
                                                    disabled={!checkboxCreativeSampling}
                                                    onChange={onChangeCheckboxNotifyProvider}
                                                >
                                                    <span className="form_label">
                                                        Notify Provider via E-mail
                                                    </span>
                                                </Checkbox>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row gutter={16}>
                                <Col span={8}>
                                    <div className="container_box--label-info">
                                        <label>Limits</label>
                                    </div>
                                </Col>

                                <Col span={16}>
                                    <div className="container_box--form-container">
                                        <div className="form_content_block--group hide_caret_after_select_value">
                                            <label className="form_label">Average Requests per Day </label>
                                            <Input className='form_control basic' autocomplete="off"
                                                value={averageRequestPerDay}
                                                onChange={onChangeAverageRequestPerDay}
                                            />
                                            <span className="error_content"> </span>
                                        </div>
                                        <div className="form_content_block--group hide_caret_after_select_value">
                                            <label className="form_label">Average Impressions per Day </label>
                                            <Input className='form_control basic' autocomplete="off"
                                                value={averageImpressionPerDay}
                                                onChange={onChangeAverageImpressionPerDay}
                                                onBlur={onBlurAverageImpressionPerDay}
                                            />
                                            <span className="error_content"> </span>
                                        </div>
                                        <div className="form_content_block--group hide_caret_after_select_value">
                                            <label className="form_label">Impressions per IP </label>
                                            <Input className={impressionPerIPIsValidError ? 'form_control basic error' : 'form_control basic'} autocomplete="off"
                                                value={impressionPerIP}
                                                onChange={onChangeAverageImpressionPerIP}
                                            />
                                            <span className="error_content"> {impressionPerIPIsValidError && <>Value must be between 1 and 50</>}</span>
                                        </div>
                                        <div className="form_content_block--group hide_caret_after_select_value mb-0">
                                            <label className="form_label">Clicks per IP </label>
                                            <Input className={clickPerIPIsValidError ? 'form_control basic error' : 'form_control basic'} autocomplete="off"
                                                value={clickPerIP}
                                                onChange={onChangeClickPerIP}
                                            />
                                            <span className="error_content"> {clickPerIPIsValidError && <>Value must be between 1 and 50</>}</span>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        {/* <div className="hr_custom mb_20"></div> */}
                        <div className="height_89_d2"></div>
                        <div className="btn_group justify-content-end gap_8 pb_50 edit_view_fixedbtn_d2">
                            {buttonProcessing ?
                                <>
                                    <button className="w_120_d2 btn btn_white_outline w_fit_content"
                                        disabled
                                    >
                                        Discard
                                    </button>
                                    <button
                                        className="w_120_d2 btn btn_primary w_fit_content loader"

                                    >
                                        <span>Update Remote Feed</span>

                                        <img
                                            src={loaderIcon}
                                            alt="USP"
                                            className="loader_icon"
                                        />
                                    </button>
                                </> :
                                <>
                                    <button className="w_120_d2 btn btn_white_outline w_fit_content" onClick={() => { handlePageViewChange("table", "no") }}> Discard </button>
                                    <button className="w_120_d2 btn btn_primary w_fit_content" onClick={handleSubmit}>Update Remote Feed</button>
                                </>
                            }

                        </div>
                    </div>
                }
                {!formVisible &&
                    <div className="d-flex justify-content-center align-items-center mt-5 pt-5">
                        <img src={FullLoader} className="mt-5" width={50} height={50} alt="" />
                    </div>
                }
            </div>
        </>
    )
}

export default RemoteFeedViewEdit
